<template>
  <div id="agora-video-call">
    <b-overlay
      :show="loading"
      variant="transparent"
      rounded="sm"
    >
      <!-- Tam ekran "Sesi Aç" katmanı kaldırıldı: ilk aramada 1-2 sn kabul/reddet butonlarının üstünü kapatıp
           tıklanamaz yapıyordu. Ses kilidi artık App.vue'da kullanıcının sitedeki ilk dokunuşunda sessizce açılıyor. -->

      <b-modal
        v-model="expanded"
        :modal-class="['call-modal', isHidden ? 'hidden-modal' : '']"
        :no-enforce-focus="isHidden"
        centered
        hide-header-close
        hide-footer
        hide-header
        no-close-on-backdrop
        no-close-on-esc
        body-class="call-body"
        dialog-class="call-dialog"
        content-class="call-content"
        size="lg"
      >
        <div
          class="minimize-icon"
          role="button"
          :aria-label="$t('Minimize')"
          :title="$t('Minimize')"
          @click="isHidden = true"
        >
          <svg width="26" height="14" viewBox="0 0 26 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.6512 10.3L22.4512 0.500015C22.7845 0.166682 23.1734 0.00534815 23.6178 0.016015C24.0623 0.0266818 24.4512 0.199125 24.7845 0.533348C25.1178 0.86757 25.2845 1.25646 25.2845 1.70001C25.2845 2.14357 25.1178 2.53246 24.7845 2.86668L14.5512 13.1333C14.2845 13.4 13.9845 13.6 13.6512 13.7333C13.3178 13.8667 12.9845 13.9333 12.6512 13.9333C12.3178 13.9333 11.9845 13.8667 11.6512 13.7333C11.3178 13.6 11.0178 13.4 10.7512 13.1333L0.484496 2.86668C0.151162 2.53335 -0.0101711 2.13868 0.000495589 1.68268C0.0111622 1.22668 0.183607 0.83246 0.517829 0.500016C0.852051 0.167572 1.24094 0.000904983 1.6845 1.61388e-05C2.12805 -0.000872705 2.51694 0.165793 2.85116 0.500016L12.6512 10.3Z" fill="white"/>
          </svg>
        </div>
        <div id="video-container">
          <div
            v-if="riveStatus"
            class="rive-container"
          >
            <canvas
              ref="canvas"
              class="rive"
              width="360"
              height="460"
            />
          </div>
          <div
            class="remote-wrap"
            style="position:relative;"
          >
            <!-- Sohbet videonun içinde konumlanır: önceden alt paneli de kapsayan kapta duruyordu,
                 mobilde mikrofon/kamera/kapat butonlarının, masaüstünde kendi önizlemenin üstüne biniyordu -->
            <vue-perfect-scrollbar
              v-if="Array.isArray(chatMessages) && chatMessages.length > 0 && callStatus === 'talking'"
              id="chat-area"
              ref="refChatArea"
              @scroll.native="onChatScroll"
              @load.native.capture="onChatContentLoad"
              class="user-chats scroll-area"
            >
              <div class="chat-messages-container">
                <!-- Mesajlar 20 sn sonra listeden silindiği için index yerine kalıcı id ile anahtarla -->
                <div
                  v-for="(m, i) in chatMessages"
                  :key="m.id || i"
                  class="chat-message-item"
                  :class="{ 'own-message': m.from === user.id }"
                >
                  <div class="message-avatar">
                    <b-avatar
                      size="30"
                      class="box-shadow-1"
                      variant="transparent"
                      :src="m.from_avatar_url"
                    />
                  </div>
                  <div class="message-content">
                    <div class="message-sender">
                      {{ m.from_user_name }}
                    </div>
                    <div class="message-text">
                      {{ m.content }}
                      <div v-if="m.translated_content">
                        <div>-------</div>
                        <div>{{ m.translated_content }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </vue-perfect-scrollbar>
            <div
              id="remotePlayerContainer"
              ref="remotePlayerContainer"
              :class="{blur: hasNudity || !faceOwn || !faceTarget}"
              class="video-container"
              style="position: relative;"
            >
              <b-img
                v-if="agoraCallUser"
                :src="agoraCallUser.profile.image"
              />

              <!-- Filigran -->
              <div
                class="watermark"
                :style="watermarkStyle"
              >
                <span>
                  {{ $store.getters['auth/userIdentifier'] }}
                </span>
                <span>
                  {{ $store.getters['auth/userName'] }}
                </span>
              </div>

              <div class="video-actions">
<!-- Hediye satışı kaldırıldı — aramadaki hediye butonu devre dışı
                <div
                  :id="socketConnected ? 'gifts-popover' : 'no-popover'"
                  class="cursor-pointer bg-light-gray"
                  @click="chooseGiftModal = true"
                >
                  <b-img
                    src="@/assets/images/gifts/gift.svg"
                    width="20"
                  />
                </div>
                -->
              </div>
            </div>
            <div
              id="localePlayerContainer"
              ref="localePlayerContainer"
              :class="{blur: hasNudity || !faceOwn || !faceTarget}"
            >
              <b-img
                v-if="profileImage"
                :src="profileImage"
              />
            </div>
          </div>
          <div class="call-bottom">
            <!-- Message Input -->
            <div
              v-if="agoraCallUser && callStatus === 'talking'"
              class="mt-1 mb-1 vc-chat-input"
            >
              <b-form
                class="chat-app-form"
                @submit.prevent="(socketConnected && chatConnection) ? sendMessage() : null"
              >
                <b-input-group
                  class="input-group-merge form-send-message"
                >
                  <b-form-input
                    v-model="chatMessage"
                    class="bg-light-gray"
                    :disabled="!socketConnected || !chatConnection"
                    :placeholder="messageInputText"
                  />
                  <template #append>
                    <b-input-group-text
                      style="padding: 2px 12px;"
                      :class="[
                        'cursor-pointer bg-light-gray',
                        { 'opacity-50': !socketConnected || !chatConnection }
                      ]"
                      @click="(socketConnected && chatConnection) ? sendMessage() : null"
                    >
                      <div style="padding: 4px; background-color: #fff; border-radius: 50%; width: 30px; height: 30px;">
                        <b-img
                          src="@/assets/images/icons/send.svg"
                          width="18"
                        />
                      </div>
                    </b-input-group-text>
                  </template>
                </b-input-group>
              </b-form>
            </div>
            <div
              v-if="agoraCallUser"
              class="call-information vc-info"
            >
              <div class="user-information vc-user">
                <b-avatar
                  size="52"
                  :src="agoraCallUser.profile.image"
                  class="vc-avatar"
                />
                <div class="vc-user-text">
                  <span class="username">
                    {{ agoraCallUser.userName }}
                  </span>
                  <span class="status">
                    <span
                      class="vc-status-dot"
                      :class="callStatus"
                    />
                    {{ message }}
                  </span>
                </div>
              </div>
              <div class="agora-call-buttons vc-buttons">
                <template v-if="agoraCallType === 'incoming' && callStatus !== 'talking'">
                  <button
                    type="button"
                    class="vc-btn reject incoming-reject"
                    :title="$t('Reject')"
                    :aria-label="$t('Reject')"
                    @click="reject"
                  >
                    <feather-icon
                      icon="PhoneOffIcon"
                      size="22"
                    />
                  </button>
                  <button
                    type="button"
                    class="vc-btn accept incoming-accept"
                    :title="$t('Accept')"
                    :aria-label="$t('Accept')"
                    @click="accept"
                  >
                    <feather-icon
                      icon="VideoIcon"
                      size="22"
                    />
                  </button>
                </template>

                <button
                  type="button"
                  class="vc-btn neutral"
                  :class="{ off: localeMuted }"
                  :title="localeMuted ? $t('Unmute') : $t('Mute')"
                  :aria-label="localeMuted ? $t('Unmute') : $t('Mute')"
                  @click="localeMuteToggle"
                >
                  <feather-icon
                    :icon="localeMuted ? 'MicOffIcon' : 'MicIcon'"
                    size="22"
                  />
                </button>
                <button
                  v-if="!switchVoice"
                  type="button"
                  class="vc-btn neutral"
                  :class="{ off: localeVideoPaused }"
                  :title="localeVideoPaused ? $t('Turn on camera') : $t('Turn off camera')"
                  :aria-label="localeVideoPaused ? $t('Turn on camera') : $t('Turn off camera')"
                  @click="localeVideoToggle"
                >
                  <feather-icon
                    :icon="localeVideoPaused ? 'VideoOffIcon' : 'VideoIcon'"
                    size="22"
                  />
                </button>
                <div
                  v-if="false && !switchVoice && callStatus === 'talking'"
                  class="mr-1"
                >
                  <b-img
                    id="switch-call-type-audio"
                    :src="iconSwitchCallType"
                    width="32"
                    height="32"
                    @click="modalSwitchCallType = true"
                  />
                  <b-tooltip
                    target="switch-call-type-audio"
                    triggers="hover"
                  >
                    <p>
                      {{ $t('Continue as a voice call') }}
                    </p>
                  </b-tooltip>
                </div>
                <button
                  v-show="canHangUp"
                  type="button"
                  class="vc-btn reject"
                  :title="$t('End call')"
                  :aria-label="$t('End call')"
                  @click="hangUp"
                >
                  <feather-icon
                    icon="PhoneOffIcon"
                    size="22"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
      <div
        v-if="isHidden"
        class="not-expanded"
        role="button"
        tabindex="0"
        :aria-label="$t('Return to call')"
        @click="isHidden = false; expanded = true"
        @keydown.enter.space.prevent="isHidden = false; expanded = true"
      >
        <div
          v-if="callStatus === 'calling'"
          class="blink"
        />
        <div
          v-if="callStatus === 'talking'"
          class="static-blink"
        />
        <b-avatar
          v-if="agoraCallUser"
          size="64"
          :src="agoraCallUser.profile.image"
        />
      </div>

      <!-- Hediye satışı kaldırıldı — hediye gönderme modalı devre dışı
<b-modal
        v-if="selectedGift"
        v-model="giftModal"
        centered
        hide-header-close
        hide-footer
        size="sm"
        :title="agoraCallUser.userName + ' için hediye'"
      >
        <div class="gifts-modal">
          <h4>{{ selectedGift.label }}</h4>
          <b-img
            :src="getImgGift(selectedGift.image)"
            width="128"
            :alt="selectedGift.label"
          />
          <h4 v-if="userGender === 'male'">
            {{ selectedGift.credits }} Elmas
          </h4>
          <b-button
            variant="primary"
            block
            :disabled="loading || connecting"
            @click="sendGift(selectedGift)"
          >
            {{ $t('Send') }}
          </b-button>
          <b-button
            variant="outline-dark"
            size="sm"
            :disabled="loading || connecting"
            @click="hideGiftModal(true)"
          >
            {{ $t('Choose Another Gift') }}
          </b-button>
        </div>
      </b-modal>
      -->

      <!-- Hediye satışı kaldırıldı — hediye seçme modalı devre dışı
<b-modal
        v-model="chooseGiftModal"
        body-class="choose-gift-modal-body"
        scrollable
        hide-footer
        size="lg"
      >
        <div class="choose-gift-modal">
          <div
            v-for="gift in gifts"
            :key="gift.productId"
            class="gift"
          >
            <b-img
              width="64"
              :alt="gift.label"
              :src="getImgGift(gift.image)"
              class="gift-image"
              @click="showGiftModal(gift)"
            />
            <p v-if="userGender === 'male'">
              {{ numberFormat(gift.credits) }}
              <b-img
                src="@/assets/images/icons/diamonds-1.svg"
                width="16"
                height="16"
                style="margin-top: -2px"
              />
            </p>
          </div>
        </div>
      </b-modal>
      -->

      <b-modal
        v-model="modalSwitchCallType"
        scrollable
        hide-footer
        size="md"
      >
        <div class="d-flex justify-content-center align-items-center flex-column p-2">
          <div class="fs-16 fw-700 text-center color-black mb-1">
            {{ $t('Are you sure you want to switch to voice call?') }}
          </div>
          <b-button
            variant="primary"
            size="sm"
            class="mt-1"
            block
            :disabled="loading"
            @click="switchCallType"
          >
            <b-spinner
              v-if="loading"
              small
            />
            {{ $t('Switch') }}
          </b-button>
        </div>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import { getCallSounds, playCallSound, retryOnNextInteraction } from '@/helpers/callSounds'
import {
  BAvatar, BButton, BForm, BFormInput, BImg, BInputGroup, BInputGroupText, BOverlay, BSpinner, BTooltip,
} from 'bootstrap-vue'
import AgoraRTC from 'agora-rtc-sdk-ng'
import useJwt from '@/auth/jwt/useJwt'
import { showNotify, throwDefaultError, numberFormat } from '@/helpers/helpers'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { Rive } from '@rive-app/webgl'
import * as faceDetection from '@tensorflow-models/face-detection'
import '@tensorflow/tfjs-backend-webgl'
import { logEvent } from 'firebase/analytics'

const iconCallAccept = require('@/assets/images/icons/call-accept.png')
const iconCallReject = require('@/assets/images/icons/call-reject.png')
const iconSwitchCallType = require('@/assets/images/icons/switch-call-type.png')

export default {
  name: 'AgoraVideoCall',
  components: {
    BSpinner,
    BButton,
    BFormInput,
    BInputGroupText,
    BForm,
    BInputGroup,
    BAvatar,
    BImg,
    BOverlay,
    BTooltip,

    VuePerfectScrollbar,
  },
  props: {
    propsNudityCheckIntervalInSecs: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      alreadyConnected: false,
      base64ImageType: 'image/jpeg',
      callStatus: 'idle',
      channelId: null,
      chatMessage: '',
      chatMessages: [],
      chooseGiftModal: false,
      expanded: true,
      faceOwn: true,
      faceTarget: true,
      giftModal: false,
      gifts: [],
      hasNudity: false,
      heartBeatStatus: 1,
      isHidden: false,
      outgoingCancelled: false,
      iconCallAccept,
      iconCallReject,
      iconSwitchCallType,
      intervalForTime: null,
      intervalForHeartBeat: null,
      localeMuted: false,
      localPlayerContainer: null,
      localeVideoPaused: false,
      loading: false,
      message: '',
      modalSwitchCallType: false,
      model: null,
      nudityCheckInFlight: {},
      nudityFrameMaxSize: 480,
      nudityFrameQuality: 0.65,
      nudityCheckIntervalInSecs: 15,
      refChatArea: null,
      remotePlayerContainer: null,
      remoteUser: null,
      remoteUserMuted: false,
      riveStatus: false,
      sendHeartBeat: true,
      selectedGift: null,
      // Uygulama genelinde ortak, ilk dokunuşta kilidi açılan zil sesleri (bkz. helpers/callSounds)
      ...getCallSounds(),
      stream: null,
      switchVoice: false,
      time: 0,
      timeCall: 0,
      timeCallInterval: null,
      timeIncomingCallTimeout: 120,
      timeOutgoingCallTimeout: 121,
      userAgoraInformation: null,
      videoWidth: 720,
      videoHeight: 1280,
      // ---> Safari Audio Unlock için eklenen değişkenler <---
      audioContext: null,
      audioUnlocked: false,
      // Yerel kamera/mikrofon açma işlemi için kilit (bkz. ensureLocalTracksPublished)
      localTracksPromise: null,
      // Kamera aç/kapa işlemi sürerken yeni tıklamayı yok saymak için
      videoToggleBusy: false,
      // Görüşme içi sohbette kullanıcı en altta mı (otomatik kaydırma için)
      chatStickToBottom: true,
      // Kamera/mikrofon açma denemesi başarısız olduysa (toggle butonları eski kurtarma yolunu kullanır)
      localTracksFailed: false,
      // Yüz algılama modeli bir kez önceden çalıştırıldı mı (bkz. warmUpModel)
      modelWarmedUp: false,
      // ---> End Safari Audio Unlock <---
      // ---> Face Zoom için eklenen değişkenler <---
      localFaceBox: null,
      remoteFaceBox: null,
      localZoomFactor: 1,
      remoteZoomFactor: 1,
      autoZoom: false,
      // ---> End Face Zoom <---

      watermarkPosition: {
        top: 20,
        left: 20,
      },
      watermarkRotation: 0,
      watermarkInterval: null,
    }
  },
  computed: {
    agoraCallUser() {
      return this.$store.getters['agora/agoraCallUser']
    },
    agoraCallType() {
      return this.$store.getters['agora/agoraCallType']
    },
    agoraChannelParameters: {
      get() {
        return this.$store.getters['agora/agoraChannelParameters']
      },
      set(value) {
        this.$store.dispatch('agora/setAgoraChannelParameters', value)
      },
    },
    agoraClient() {
      return this.$store.getters['agora/agoraClient']
    },
    agoraOptions() {
      return this.$store.getters['agora/agoraOptions']
    },
    // Görüşme içi sohbet mesajları bu numarayla gönderilir. Önceden giden aramada da önce son gelen arama
    // isteğine (callRequestInfo) bakılıyordu; o kayıt eski bir aramadan kaldıysa mesajlar eski aramanın
    // numarasıyla gidiyor ve karşı tarafta görünmüyordu ("bazen görünüyor bazen görünmüyor").
    // Artık arama yönüne göre doğru kaynak kullanılır.
    callId() {
      return this.currentCallId() || null
    },
    callerId() {
      if (this.agoraCallType === 'incoming') {
        const callerId = this.callRequestInfo?.agoraCall?.callerId
        if (callerId) return callerId
      }
      return this.agoraCallUser ? this.agoraCallUser.id : null
    },
    callRequestInfo() {
      return this.$store.getters['agora/callRequestInfo']
    },
    connection() {
      return this.$store.getters['socket/connection']
    },
    connecting() {
      return this.$store.getters['socket/connecting']
    },
    messageInputText() {
      return this.socketConnected ? this.$t('Send message') : this.$t('Connecting to the system. Please wait.')
    },
    profileImage() {
      return this.$store.getters['auth/profileImage']
    },
    chatConnection() {
      return this.$store.getters['socket/chatConnection']
    },
    socketConnected: {
      get() {
        return this.$store.getters['socket/connected']
      },
      set(value) {
        this.$store.commit('socket/updateConnected', value)
      },
    },
    user() {
      return this.$store.getters['auth/user']
    },
    userGender() {
      return this.$store.getters['auth/userGender']
    },
    userZoomStatus() {
      return this.$store.getters['auth/userZoomStatus']
    },
    talking() {
      return this.callStatus === 'talking' || (this.agoraCallType === 'outgoing' && this.callStatus === 'calling')
    },
    // Giden aramada kapatma butonu en baştan görünür: önceden sunucu arama kaydını oluşturana kadar
    // (callStatus 'idle') hiç görünmüyordu; yanıt yavaşsa arayan aramayı iptal edemiyordu
    canHangUp() {
      return this.talking || (this.agoraCallType === 'outgoing' && this.callStatus === 'idle' && !this.outgoingCancelled)
    },
    watermarkStyle() {
      return {
        top: `${this.watermarkPosition.top}%`,
        left: `${this.watermarkPosition.left}%`,
        transform: `translate(-50%, -50%) rotate(${this.watermarkRotation}deg)`,
      }
    },
  },
  watch: {
    // Görüşme içi sohbet: yeni mesaj gelince en alta kaydır. Önceden yalnızca mesaj GÖNDERİLİRKEN kaydırılıyordu
    // (gönderilen mesaj da sunucudan sonra geldiği için o an listede değildi), gelen mesajlar alta kayıp kalıyordu.
    // Kullanıcı yukarı kaydırıp eski mesajları okuyorsa okumayı bölme; kendi mesajında her zaman kaydır.
    'chatMessages.length': function onChatMessagesLength(newLength, oldLength) {
      // Tüm mesajlar silinince sohbet alanı kapanıyor; yeniden açıldığında en alttan başlasın
      if (newLength === 0) this.chatStickToBottom = true
      if (newLength <= oldLength) return

      // Alt sınırda olup olmadığını mesaj anında ölçmek yerine kaydırma olaylarından takip edilen bayrağa bak:
      // avatar resmi kaydırmadan SONRA yüklenip içeriği uzatınca ölçüm "kullanıcı yukarıda" sanıyor ve
      // sonraki mesajlarda kaydırma yapılmıyordu.
      const lastMessage = this.chatMessages[this.chatMessages.length - 1]
      const isOwn = lastMessage && this.user && lastMessage.from === this.user.id

      if (this.chatStickToBottom || isOwn) this.scrollChatToBottom()
    },
    async callStatus(status) {
      this.stopAllSounds()

      if (this.callStatus === 'calling') {
        // ---> Safari audio unlock kontrolü <---
        console.log('🔊 [Call Status] Calling durumu, Safari audio unlock kontrolü yapılıyor...')
        if (!this.audioUnlocked) {
          // Kullanıcı etkileşimi yokken audioContext.resume() hiç dönmeyebiliyor; en fazla 1 sn bekle
          await Promise.race([
            this.unlockSafariAudio(),
            new Promise(resolve => setTimeout(resolve, 1000)),
          ])
        }
        // ---> End Safari audio unlock kontrolü <---

        // Unlock beklenirken durum değiştiyse (ör. karşı taraf açtı) artık zil çalma;
        // aksi halde stopAllSounds() başlamış play()'i kesiyor ve AbortError oluşuyordu
        if (this.callStatus !== status) return

        if (this.agoraCallType === 'outgoing' && this.soundOutgoingCall) {
          this.playRingtone(this.soundOutgoingCall, status)
        } else if (this.agoraCallType === 'incoming' && this.soundIncomingCall) {
          this.playRingtone(this.soundIncomingCall, status)
        }
      } else if (this.callStatus === 'ended') {
        // ---> Safari audio unlock kontrolü <---
        console.log('🔊 [Call Status] Call ended durumu, Safari audio unlock kontrolü yapılıyor...')
        if (!this.audioUnlocked) {
          console.log('🔊 [Call Status] Audio unlock gerekli, unlockSafariAudio çağrılıyor...')
          await this.unlockSafariAudio()
        } else {
          console.log('🔊 [Call Status] Audio zaten unlock, ses çalma işlemine devam...')
        }
        // ---> End Safari audio unlock kontrolü <---
        if (this.soundEndCall) {
          console.log('🔊 [Call Status] End call sesi çalınıyor...')
          console.log('🔊 [Call Status] soundEndCall objesi:', this.soundEndCall)
          console.log('🔊 [Call Status] soundEndCall.readyState:', this.soundEndCall.readyState)
          // ---> Audio unlock kontrolü <---
          if (this.audioUnlocked) {
            this.soundEndCall.loop = false
            playCallSound(this.soundEndCall).then(() => {
              console.log('🔊 [Call Status] End call sesi başarıyla çalındı')
            }).catch(error => {
              console.error('🔊 [Call Status] End call sesi çalınamadı:', error)
            })
            setTimeout(() => {
              this.stopAllSounds()
            }, 3000)
          } else {
            console.log('🔊 [Call Status] Audio unlock olmadığı için end call sesi çalınmıyor')
          }
          // ---> End audio unlock kontrolü <---
        }
      }
    },
    connecting() {},
    // Sohbet bağlantısı arama sırasında yenilenirse (yeniden bağlanma, token değişimi) mesaj dinleyicisini
    // yeni bağlantıya taşı; önceden eski bağlantıda kaldığı için yeni mesajlar görünmüyordu
    chatConnection(newConnection, oldConnection) {
      if (oldConnection) oldConnection.off('receiveCallMsg', this.onReceiveCallMsg)
      if (newConnection) newConnection.on('receiveCallMsg', this.onReceiveCallMsg)
    },
    // Küçültülen arama modal'ı açık kalıyor (yalnızca görünmez); önceden body'de modal-open kaldığı için
    // sayfa kaydırılamıyor, sohbet widget'ı gizli kalıyordu. Küçültülünce sayfayı serbest bırak.
    isHidden(hidden) {
      if (!this.expanded) return
      document.body.classList.toggle('modal-open', !hidden)
      if (hidden) document.body.style.paddingRight = ''
    },
    expanded(value) {
      if (value) {
        setTimeout(() => {
          if (this.agoraChannelParameters.localVideoTrack) {
            this.agoraChannelParameters.localVideoTrack.play(this.$refs.localePlayerContainer)
          }
          if (this.agoraChannelParameters.remoteVideoTrack) {
            this.agoraChannelParameters.remoteVideoTrack.play(this.$refs.remotePlayerContainer)
          }
        }, 33)
      }
    },
    timeCall(val) {
      if (this.agoraCallType === 'incoming') {
        if (val >= this.timeIncomingCallTimeout) {
          this.reject()
        }
      } else if (this.agoraCallType === 'outgoing') {
        if (val >= this.timeOutgoingCallTimeout) {
          showNotify(this.$toast, this.$t('User didn\'t answer the call'), 'info')
          this.leave()
        }
      }
    },
    userZoomStatus(value) {
      this.autoZoom = !!value
    },
  },
  mounted() {
    this.startWatermarkAnimation()
    // Mobil klavye: arama içi sohbete yazarken tam ekran düzen (100dvh) klavyeyle küçülmüyor,
    // tarayıcı ekranı kaydırıyor ve video/küçültme butonu ekrandan çıkıyordu. Klavye açıkken
    // düzen görünen alana eşitlenir (bkz. body.vc-kb-open stilleri).
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.onCallViewportChange)
      window.visualViewport.addEventListener('scroll', this.onCallViewportChange)
    }
  },
  beforeDestroy() {
    if (this.watermarkInterval) {
      clearInterval(this.watermarkInterval)
    }
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.onCallViewportChange)
      window.visualViewport.removeEventListener('scroll', this.onCallViewportChange)
    }
    document.body.classList.remove('vc-kb-open')
    document.documentElement.style.removeProperty('--vc-h')
    document.documentElement.style.removeProperty('--vc-top')
  },
  async created() {
    // ---> Safari audio unlock durumu kontrolü <---
    const savedAudioUnlocked = localStorage.getItem('audioUnlocked')
    if (savedAudioUnlocked === '1') {
      this.audioUnlocked = true
      console.log('🔊 [Created] localStorage\'dan audioUnlocked durumu yüklendi:', this.audioUnlocked)
    } else {
      console.log('🔊 [Created] localStorage\'da audioUnlocked bulunamadı, varsayılan false')
    }
    // ---> End Safari audio unlock durumu kontrolü <---

    // ---> Ses dosyalarının durumu kontrolü <---
    console.log('🔊 [Created] Ses dosyaları durumu:')
    console.log('🔊 [Created] soundEndCall:', this.soundEndCall)
    console.log('🔊 [Created] soundIncomingCall:', this.soundIncomingCall)
    console.log('🔊 [Created] soundOutgoingCall:', this.soundOutgoingCall)
    // ---> End ses dosyaları durumu kontrolü <---

    this.message = `${this.$t('Connecting')}...`
    await this.startAgoraClient()
    // Bileşen bu sırada kapatıldıysa (ör. arama ekranı yeniden kuruldu) sahipsiz bir arama isteği gönderme
    // eslint-disable-next-line no-underscore-dangle
    if (this._isDestroyed) return
    this.message = this.$t('Connected')

    if (this.agoraClient && this.agoraCallUser) {
      if (this.agoraCallType === 'outgoing') {
        this.expanded = true
        this.message = `${this.$t('Calling')}...`
        await this.startCallingTime()
        await this.startCall()
      } else if (this.agoraCallType === 'incoming') {
        this.callStatus = 'calling'
        this.message = `${this.$t('Incoming call')}...`
        await this.startCallingTime()
        // Heartbeat göndermeyi başlat
        // this.heartBeatStatus = 6 // TODO: kapatılacak
        // this.startSendHeartBeat(this.callRequestInfo.agoraCall.callId, 5) // TODO: kapatılacak
      }
    }

    // Props olarak gelen propsNudityCheckIntervalInSecs değerini ata
    if (this.propsNudityCheckIntervalInSecs) {
      this.nudityCheckIntervalInSecs = this.propsNudityCheckIntervalInSecs
    }

    if (this.connection) {
      // Cancel call / switch call type gelmesini dinle.
      // Handler'lar method olarak tutuluyor ki destroyed'da socket'ten sökülebilsin;
      // aksi halde önceki aramaların dinleyicileri birikip yeni aramayı kapatıyor.
      this.connection.on('cancelCallRequest', this.onCancelCallRequest)
      this.connection.on('switchCallType', this.onSwitchCallType)
    }

    // Görüşme içi sohbet mesajlarını dinle (bağlantı değişirse chatConnection izleyicisi yeniden bağlar)
    if (this.chatConnection) {
      this.chatConnection.on('receiveCallMsg', this.onReceiveCallMsg)
    }

    // Hediye satışı kaldırıldı
    // this.getGifts()

    this.loadModel()

    // ---> Safari için sayfa görünürlük değişikliği dinleyicisi <---
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
    // ---> End Safari visibility change listener <---
  },
  destroyed() {
    // ---> Event listener temizleme <---
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    // Önceden sökülmüyordu; her aramada bir dinleyici daha birikiyordu
    if (this.chatConnection) {
      this.chatConnection.off('receiveCallMsg', this.onReceiveCallMsg)
    }

    // Ses kilidi için açılan AudioContext'i kapat: önceden hiç kapatılmıyordu, Safari'de birkaç aramadan
    // sonra yeni ses motoru açılamıyor ve zil/ses bozuluyordu
    if (this.audioContext && this.audioContext.state !== 'closed') {
      this.audioContext.close().catch(() => {})
    }
    // ---> End event listener temizleme <---

    // Interval leri temizle
    this.clearIntervals()

    this.stopAllSounds()

    if (this.connection) {
      this.connection.off('cancelCallRequest', this.onCancelCallRequest)
      this.connection.off('switchCallType', this.onSwitchCallType)
    }

    if (this.alreadyConnected) {
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    }
  },
  methods: {
    currentCallId() {
      return this.agoraCallType === 'outgoing'
        ? this.userAgoraInformation?.callId
        : this.callRequestInfo?.agoraCall?.callId
    },
    onReceiveCallMsg(chatMsgDTO) {
      // Random id ekle
      // eslint-disable-next-line no-param-reassign
      chatMsgDTO['id'] = Math.random().toString(36).substring(2, 15)

      // Mesajı ekle
      this.chatMessages.push(chatMsgDTO)

      // 20 saniye sonra bu mesajı sil
      setTimeout(() => {
        const index = this.chatMessages.findIndex(msg => msg.id === chatMsgDTO.id
            || (msg.fromId === chatMsgDTO.fromId
                && msg.dateSent === chatMsgDTO.dateSent
                && msg.message === chatMsgDTO.message))

        if (index !== -1) {
          this.chatMessages.splice(index, 1)
        }
      }, 20000) // 20 saniye = 20000 milisaniye
    },
    async onCancelCallRequest(data, ack) {
      if (typeof ack === 'function') ack('cancelCallRequestACK')

      // Başka bir aramaya ait iptal ise bu aramayı kapatma
      const currentCallId = this.currentCallId()
      if (data && data.callId && currentCallId && data.callId !== currentCallId) return

      await this.leave(false, true)
    },
    onSwitchCallType(data) {
      this.handleSwitchCallType(data, 'audio')
    },
    async accept() {
      if (this.callRequestInfo) {
        await this.$store.dispatch('agora/setAgoraOptions', {
          channel: this.callRequestInfo.agoraCall.agoraChannelName,
          token: this.callRequestInfo.agoraCall.agoraToken,
          uid: this.callRequestInfo.agoraCall.agoraUid,
        })
        await this.join()

        // Gelen aramada yüz algılama modeli kabul edildikten sonra ısıtılır (model henüz yüklenmediyse atlanır)
        this.scheduleWarmUpModel()

        // Heartbeat göndermeyi başlat
        // this.heartBeatStatus = 6 // TODO : açılacak
        // this.startSendHeartBeat(this.callRequestInfo.agoraCall.callId, 5) // TODO : açılacak
      }
    },
    async cancelCall() {
      if (this.agoraCallType === 'outgoing' && this.userAgoraInformation) {
        if (this.sendHeartBeat) {
          useJwt.appCallCancel({ callId: this.userAgoraInformation.callId })
        }
      }

      if (this.agoraCallType === 'incoming' && this.callRequestInfo) {
        useJwt.appCallCancel({ callId: this.callRequestInfo.agoraCall.callId })
      }
    },
    async clearIntervals() {
      await this.stopCallingTime()

      if (this.intervalForTime) {
        clearInterval(this.intervalForTime)
        this.intervalForTime = null
      }
      if (this.intervalForHeartBeat) {
        clearInterval(this.intervalForHeartBeat)
        this.intervalForHeartBeat = null
      }

      // Destroy the local video track.
      if (this.agoraChannelParameters?.localVideoTrack) {
        await this.agoraChannelParameters.localVideoTrack.stop()
        await this.agoraChannelParameters.localVideoTrack.close()
        this.agoraChannelParameters.localVideoTrack = null
      }

      // Destroy the local audio track.
      if (this.agoraChannelParameters?.localAudioTrack) {
        await this.agoraChannelParameters.localAudioTrack.stop()
        await this.agoraChannelParameters.localAudioTrack.close()
        this.agoraChannelParameters.localAudioTrack = null
      }

      // Destroy the remote video track.
      if (this.agoraChannelParameters?.remoteVideoTrack) {
        await this.agoraChannelParameters.remoteVideoTrack.stop()
        await this.agoraChannelParameters.remoteVideoTrack.close()
        this.agoraChannelParameters.remoteVideoTrack = null
      }
    },
    async closeAgoraCall(callId, sendCompletedHeartBeat = true, sendHeartBeatLater = false) {
      if (sendCompletedHeartBeat && callId && this.callStatus !== 'calling' && this.callStatus !== 'idle') {
        // Backend e tamamlandı olarak heart beat gönder
        if (sendHeartBeatLater) {
          setTimeout(() => {
            this.heartBeat({ callId, status: 3 })
          }, 800)
        } else {
          this.heartBeat({ callId, status: 3 })
        }
      }

      this.callStatus = 'ended'

      // Firebase Analytics Event
      if (this.agoraCallType === 'outgoing' && window.firebaseAnalytics && this.agoraCallUser) {
        logEvent(window.firebaseAnalytics, 'web_end_call', {
          fromId: this.agoraCallUser.id,
          toId: this.agoraChannelParameters.remoteUid,
          duration: this.time,
        })
      }

      // Interval leri temizle
      await this.clearIntervals()

      // Leave the channel (arama sunucu yanıtından önce kapatıldıysa istemci henüz kanala girmemiş olabilir)
      if (this.agoraClient) {
        try {
          await this.agoraClient.leave()
        } catch (error) {
          // kanala hiç girilmediyse leave hata verebilir; kapatma akışı yine de tamamlanmalı
        }
      }
      this.message = this.$t('Closed')
      this.callStatus = 'idle'

      await this.$store.dispatch('agora/setAgoraCalling', false)
      await this.$store.dispatch('agora/setAgoraCallUser', null)
      await this.$store.dispatch('agora/setCallRequestInfo', null)
      await this.$store.dispatch('agora/setShowAgoraCall', false)
      await this.$store.dispatch('agora/setShowAgoraVideoCall', false)
    },
    getDateForHuman(timeLeft) {
      if (timeLeft <= 0) {
        return '00:00'
      }

      let result = ''
      let totalSeconds = timeLeft

      const hours = Math.floor(totalSeconds / (60 * 60))
      totalSeconds -= hours * (60 * 60)

      const minutes = Math.floor(totalSeconds / (60))
      totalSeconds -= minutes * 60

      const seconds = Math.floor(totalSeconds % 60)

      result = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`

      if (hours > 0) {
        result = `${hours.toString().padStart(2, '0')}:${result}`
      }

      return result
    },
    getGifts(showLoading = false) {
      if (showLoading) {
        this.loading = true
      }

      useJwt.getGifts()
        .then(response => {
          this.gifts = response.data.body
        })
        .catch(() => {})
        .finally(() => {
          if (showLoading) {
            this.loading = false
          }
        })
    },
    getImgGift(name) {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/images/gifts/${name}`)
    },
    async handleSwitchCallType(data, newType = 'audio') {
      try {
        // Update call ID from switchCallType event
        this.userAgoraInformation.callId = data.callId

        // If switching to audio call
        if (newType === 'audio') {
          this.switchVoice = true

          // Stop video tracks
          if (this.agoraChannelParameters?.localVideoTrack) {
            await this.agoraChannelParameters.localVideoTrack.stop()
            await this.agoraChannelParameters.localVideoTrack.close()
            this.agoraChannelParameters.localVideoTrack = null
          }

          if (this.agoraChannelParameters?.remoteVideoTrack) {
            await this.agoraChannelParameters.remoteVideoTrack.stop()
            await this.agoraChannelParameters.remoteVideoTrack.close()
            this.agoraChannelParameters.remoteVideoTrack = null
          }

          // Update UI states
          this.localeVideoPaused = true

          // Hide video containers
          if (this.$refs.localePlayerContainer) {
            // this.$refs.localePlayerContainer.style.display = 'none'
          }
          if (this.$refs.remotePlayerContainer) {
            // this.$refs.remotePlayerContainer.style.display = 'none'
          }

          // Make sure audio is still working
          if (!this.agoraChannelParameters.localAudioTrack) {
            // this.agoraChannelParameters.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack()
            // await this.agoraClient.publish([this.agoraChannelParameters.localAudioTrack])
            this.agoraChannelParameters.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack()
            await this.agoraChannelParameters.localAudioTrack.setEnabled(true)
          }

          showNotify(this.$toast, this.$t('Switched to audio call'), 'info')

          this.modalSwitchCallType = false
        }
      } catch (error) {
        showNotify(this.$toast, this.$t('Failed to switch call type'), 'error')
      }
    },
    heartBeat(payload) {
      if (this.sendHeartBeat) {
        useJwt.heartBeat(payload)
          .then(response => {
            const { nudity, callerFace, calleeFace } = response.data.body

            this.hasNudity = nudity

            if (this.agoraCallType === 'outgoing') {
              this.faceOwn = typeof callerFace === 'boolean' ? callerFace : true
              this.faceTarget = typeof calleeFace === 'boolean' ? calleeFace : true
            } else if (this.agoraCallType === 'incoming') {
              this.faceOwn = typeof calleeFace === 'boolean' ? calleeFace : true
              this.faceTarget = typeof callerFace === 'boolean' ? callerFace : true
            }

            if (!this.faceOwn) {
              showNotify(this.$toast, this.$t('text_face_alert_own'), 'info')
            }

            if (!this.faceTarget) {
              showNotify(this.$toast, this.$t('text_face_alert_target'), 'info')
            }
          })
          .catch(error => {
            const errorResponse = error.response
            // eslint-disable-next-line eqeqeq
            if (errorResponse && errorResponse.status === 400 && errorResponse.data?.header?.error?.errorCode == '514') {
              showNotify(this.$toast, this.$t('User didn\'t answer the call'), 'info')
              this.sendHeartBeat = false
              if (this.agoraCallType === 'outgoing') {
                this.leave()
              } else if (this.agoraCallType === 'incoming') {
                this.reject()
              }
              // eslint-disable-next-line eqeqeq
            } else if (errorResponse && errorResponse.status === 400 && errorResponse.data?.header?.error?.errorCode == '517') {
              showNotify(this.$toast, this.$t('Your credit is over'), 'info')
              // Kullanıcıyı market sayfasına yönlendir
              this.$router.push('/market')
              this.sendHeartBeat = false
              if (this.agoraCallType === 'outgoing') {
                this.leave()
              } else if (this.agoraCallType === 'incoming') {
                this.reject()
              }
            }
            // else if (errorResponse && errorResponse.status === 400 && errorResponse.data?.header?.error?.errorCode == "532") {
            //   showNotify(this.$toast, this.$t(errorResponse.data?.header?.error?.message) + '. ' + this.$t('Conversation ended.'), 'info')
            //   this.sendHeartBeat = false
            //   if (this.agoraCallType === 'outgoing') {
            //     this.leave()
            //   } else if (this.agoraCallType === 'incoming') {
            //     this.reject()
            //   }
            // }
          })
      }
    },
    hideGiftModal(showChooseAnotherGift = false) {
      this.selectedGift = null
      this.giftModal = false
      this.showGifts = true

      if (showChooseAnotherGift) this.chooseGiftModal = true
    },
    async join() {
      // const uid = this.agoraCallType === 'incoming' ? this.agoraOptions.uid.toString() : this.agoraOptions.uid

      // eslint-disable-next-line radix
      this.channelId = await this.agoraClient.join(this.agoraOptions.appId, this.agoraOptions.channel, this.agoraOptions.token, parseInt(this.agoraOptions.uid))

      await this.ensureLocalTracksPublished()
    },
    // Mikrofon + kamerayı TEK yerden, tek seferde açıp yayınlar.
    // Önceden join() ve CONNECTED olayı aynı anda ayrı ayrı kamera açıyordu; kamera iki kez istendiği için
    // açılış uzuyor (karşı tarafa görüntü ~10 sn sonra geliyordu) ve join()'in açtığı track hiç yayınlanmıyordu.
    ensureLocalTracksPublished() {
      if (this.localTracksPromise) return this.localTracksPromise

      this.localTracksPromise = (async () => {
        let audioTrack = null
        let videoTrack = null
        try {
          // Tek getUserMedia çağrısı ile mikrofon ve kamera birlikte (ayrı ayrı açmaktan hızlı)
          [audioTrack, videoTrack] = await AgoraRTC.createMicrophoneAndCameraTracks()

          if (this.localeVideoPaused) {
            // Kamera kapalı girildiyse görüntü HİÇ yayınlanmaz, yalnızca ses gider.
            // Önceden önce yayınlanıp hemen ardından kapatılıyordu; karşı tarafın aboneliği bu yarışta
            // bozuluyor, kamera sonradan açılınca görüntü karşıya hiç ulaşmıyordu.
            await videoTrack.setEnabled(false)
            await this.agoraClient.publish([audioTrack])
          } else {
            if (this.$refs.localePlayerContainer) {
              videoTrack.play(this.$refs.localePlayerContainer)
            }
            await this.agoraClient.publish([audioTrack, videoTrack])
          }
        } catch (error) {
          // Yayına alınamadıysa açılan kamera/mikrofonu kapat (ışık açık kalmasın)
          if (audioTrack) audioTrack.close()
          if (videoTrack) videoTrack.close()
          this.localeMuted = true
          this.localTracksFailed = true
          // Hata olursa bir sonraki denemede yeniden açılabilsin
          this.localTracksPromise = null
          throw error
        }

        // Track'ler yayına alındıktan SONRA butonlara açılır; yayın sürerken basılan buton
        // yarım hazırlanmış track'i değiştirmesin, tercih olarak kaydedilip aşağıda uygulanır
        this.agoraChannelParameters.localAudioTrack = audioTrack
        this.agoraChannelParameters.localVideoTrack = videoTrack
        // Önceki deneme başarısız olduysa localeMuted "mikrofon yok" anlamında true kalmıştı;
        // bu bir kullanıcı tercihi değil, yeniden başarılı açılışta sıfırla (yoksa mikrofon kapalı kalırdı)
        if (this.localTracksFailed) this.localeMuted = false
        this.localTracksFailed = false

        // Bağlanmadan önce mikrofon/kamera butonuna basıldıysa o tercihi şimdi uygula
        // (önceden burada localeMuted her zaman false yapılıyor, tercih kayboluyordu)
        // Uygulanamazsa buton durumu gerçeği göstersin (ör. "kapalı" görünüp mikrofon açık kalmasın)
        if (this.localeMuted) {
          try {
            await audioTrack.setMuted(true)
          } catch (error) {
            this.localeMuted = false
          }
        }
      })()

      return this.localTracksPromise
    },
    hangUp() {
      if (this.talking) {
        this.leave()
        return
      }
      // Sunucu henüz arama kaydını döndürmedi: aramayı yerelde kapat; yanıt sonradan gelirse
      // startCall onu iptal eder (karşı tarafın telefonu boşuna çalmasın)
      if (this.agoraCallType === 'outgoing' && this.callStatus === 'idle') {
        this.outgoingCancelled = true
        this.$store.dispatch('agora/setAgoraCalling', false)
        this.closeAgoraCall(null, false)
      }
    },
    async leave(sendCancel = true, sendHeartBeatLater = false) {
      // Süreyi durdur
      clearInterval(this.intervalForTime)

      // Store'da çağrı durumunu false yap
      await this.$store.dispatch('agora/setAgoraCalling', false)

      // Arama yapılıyor aşamasındaysa backend e arama bitirme isteği gönder
      if (this.callStatus === 'calling' && sendCancel) {
        await this.cancelCall()
      }

      setTimeout(() => {
        if (this.agoraCallType === 'outgoing') {
          this.closeAgoraCall(this.userAgoraInformation.callId, true, sendHeartBeatLater)
        } else if (this.agoraCallType === 'incoming') {
          this.closeAgoraCall(this.callRequestInfo?.agoraCall?.callId)
        }
      }, 333)

      // Refresh the page for reuse
      // window.location.reload();
    },
    async loadModel() {
      this.loading = true
      // Yüz algılama modelini yükleyin
      this.model = await faceDetection.createDetector(
        faceDetection.SupportedModels.MediaPipeFaceDetector,
        {
          runtime: 'tfjs',
        },
      )
      this.loading = false

      // Giden aramada model, karşı taraf açmadan (arama çalarken) ısıtılsın.
      // Gelen aramada çalarken ısıtılmaz (kabul/reddet butonlarına basılırken takılma yapmasın);
      // kabul edildikten sonra accept() içinde ısıtılır.
      if (this.agoraCallType === 'outgoing') this.scheduleWarmUpModel()
    },
    // Isıtmayı tarayıcı boştayken çalıştır ki tıklamaları ya da bağlantı kurulumunu geciktirmesin
    scheduleWarmUpModel() {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(() => this.warmUpModel(), { timeout: 3000 })
      } else {
        setTimeout(() => this.warmUpModel(), 0)
      }
    },
    // TensorFlow ilk çalıştırmada GPU shader'larını derliyor ve sayfayı birkaç saniye kilitliyordu
    // (aranan tarafta görüşmenin ~5. saniyesindeki donma). Boş küçük bir kareyle bir kez önceden çalıştırılır.
    // Moderasyon / yüz algılama mantığı değişmez.
    async warmUpModel() {
      if (!this.model || this.modelWarmedUp) return
      this.modelWarmedUp = true
      try {
        const canvas = document.createElement('canvas')
        canvas.width = 64
        canvas.height = 64
        await this.model.estimateFaces(canvas, { flipHorizontal: false })
      } catch (error) {
        // Isıtma başarısız olsa da gerçek kontroller normal şekilde çalışmaya devam eder
        this.modelWarmedUp = false
      }
    },
    // Kontrolü tarayıcı boşta iken çalıştır (en geç 2 sn içinde); kullanıcı butona basarken araya girip
    // arayüzü kilitlemesin. Kontrolün kendisi (nudityDetection) aynen çalışır.
    scheduleNudityDetection() {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(() => this.nudityDetection(), { timeout: 2000 })
      } else {
        this.nudityDetection()
      }
    },
    async localeMuteToggle() {
      // Bağlantı kurulmadan önce (mikrofon henüz açılmadı): yalnızca tercihi kaydet;
      // ensureLocalTracksPublished mikrofonu açınca bu tercih uygulanır
      if (!this.agoraChannelParameters?.localAudioTrack && !this.localTracksFailed) {
        this.localeMuted = !this.localeMuted
        return
      }
      if (this.agoraChannelParameters?.localAudioTrack) {
        if (this.localeMuted) {
          await this.agoraChannelParameters.localAudioTrack.setMuted(false)
          this.localeMuted = false
        } else {
          await this.agoraChannelParameters.localAudioTrack.setMuted(true)
          this.localeMuted = true
        }
      } else if (this.localeMuted) {
        try {
          // Create a local audio track from the audio sampled by a microphone.
          this.agoraChannelParameters.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack()
          await this.agoraChannelParameters.localAudioTrack.setEnabled(true)
          // Create a local video track from the video captured by a camera.
          // Create a local video track from the video captured by a camera.
          await AgoraRTC.createCameraVideoTrack().then(track => {
            this.agoraChannelParameters.localVideoTrack = track
          })
          await this.agoraChannelParameters.localVideoTrack.setEnabled(true)

          this.localeMuted = false
        } catch (e) {
          this.localeMuted = true
        }
      }
    },
    async localeVideoToggle() {
      // Hızlı art arda tıklamada Agora işlemleri çakışıp hata veriyordu
      if (this.videoToggleBusy) return
      this.videoToggleBusy = true
      try {
        await this.toggleLocalVideo()
      } catch (error) {
        console.warn('Kamera aç/kapa başarısız:', error)
        showNotify(this.$toast, this.$t('There was an unexpected error'), 'danger')
      } finally {
        this.videoToggleBusy = false
      }
    },
    async toggleLocalVideo() {
      const videoTrack = this.agoraChannelParameters?.localVideoTrack
      // Bağlantı kurulmadan önce (kamera henüz açılmadı): yalnızca tercihi kaydet;
      // ensureLocalTracksPublished kamerayı açınca bu tercih uygulanır
      if (!videoTrack && !this.localTracksFailed) {
        this.localeVideoPaused = !this.localeVideoPaused
        return
      }
      if (videoTrack) {
        // setEnabled kamerayı (ışığı dahil) kapatır/açar; yayındaki track'i SDK kendisi unpublish/publish eder
        // ve ses track'ine dokunmaz. Önceden argümansız unpublish() sesi de yayından kaldırıyor,
        // hatalar sessizce yutuluyordu; buton bu yüzden çoğu zaman tepkisiz kalıyordu.
        if (this.localeVideoPaused) {
          await videoTrack.setEnabled(true)
          // Kamera kapalı girildiyse track hiç yayınlanmamıştır; setEnabled yalnızca yayındaki track'i
          // yeniden yayınlar. Yayında değilse burada yayına al, yoksa karşı taraf görüntüyü hiç almaz.
          if (!this.agoraClient.localTracks.includes(videoTrack)) {
            await this.agoraClient.publish(videoTrack)
          }
          if (this.$refs.localePlayerContainer) {
            videoTrack.play(this.$refs.localePlayerContainer)
          }
          this.localeVideoPaused = false
        } else {
          await videoTrack.setEnabled(false)
          this.localeVideoPaused = true
        }
      } else if (this.localeVideoPaused) {
        try {
          // Create a local audio track from the audio sampled by a microphone.
          this.agoraChannelParameters.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack()
          await this.agoraChannelParameters.localAudioTrack.setEnabled(true)
          // Create a local video track from the video captured by a camera.
          // Create a local video track from the video captured by a camera.
          await AgoraRTC.createCameraVideoTrack().then(track => {
            this.agoraChannelParameters.localVideoTrack = track
          })
          await this.agoraChannelParameters.localVideoTrack.setEnabled(true)
          // Publish the local audio and video tracks in the channel.
          await this.agoraClient.publish([this.agoraChannelParameters.localAudioTrack, this.agoraChannelParameters.localVideoTrack])

          this.localeVideoPaused = false
        } catch (e) {
          this.localeVideoPaused = true
        }
      }
    },
    async nudityDetection() {
      if (this.$refs.localePlayerContainer) {
        const videoElement = this.$refs.localePlayerContainer.querySelector('video')
        const videoElementRemote = this.$refs.remotePlayerContainer.querySelector('video')

        let callId = null
        if (this.agoraCallType === 'outgoing' && this.userAgoraInformation) {
          callId = this.userAgoraInformation.callId
        }

        if (this.agoraCallType === 'incoming' && this.callRequestInfo) {
          callId = this.callRequestInfo.agoraCall.callId
        }

        if (videoElement) {
          const frame = await this.captureNudityFrame(videoElement, true)

          if (callId && frame) {
            // eslint-disable-next-line radix
            this.sendCheckNudity(parseInt(callId), this.$store.getters['auth/userIdentifier'], frame.blob, frame.mimeType)

            // eslint-disable-next-line radix
            this.sendFaceDetection(parseInt(callId), frame.dataUrl)
          }
        } else {
          // useJwt.faceDetect({ call_id: callId, detect: false })
        }

        if (videoElementRemote) {
          const frameRemote = await this.captureNudityFrame(videoElementRemote, true)

          if (callId && frameRemote) {
            // eslint-disable-next-line radix
            this.sendCheckNudity(parseInt(callId), parseInt(this.agoraChannelParameters.remoteUid), frameRemote.blob, frameRemote.mimeType)

            // Remote video için face detection ve zoom
            this.sendRemoteFaceDetection(frameRemote.dataUrl)
          }
        }
      }
    },
    sendCheckNudity(callId, userId, imageData, mimeType = this.base64ImageType) {
      const inFlightKey = `${callId}:${userId}`
      if (this.nudityCheckInFlight[inFlightKey]) {
        return
      }

      const imageBlob = imageData instanceof Blob ? imageData : this.dataUrlToBlob(imageData, mimeType)
      const payload = new FormData()
      payload.append('mime_type', imageBlob.type || mimeType)
      payload.append('user_id', userId)
      payload.append('call_id', callId)
      payload.append('image', imageBlob, `nudity-frame.${this.mimeExtension(imageBlob.type || mimeType)}`)

      this.nudityCheckInFlight[inFlightKey] = true
      useJwt.checkNudity(payload)
        .then(response => {
          if (response?.data?.body?.is_nudity_exists) {
            showNotify(this.$toast, this.$t('Nudity detected. If it continues, the call will be terminated.'), 'info')

            this.hasNudity = true
          }

          // Ergen algılanırsa yayını kapat
          if (response?.data?.body?.is_child_exists) {
            showNotify(this.$toast, this.$t('isChildWarningText'), 'danger')
            showNotify(this.$toast, this.$t('isChildWarningText2'), 'danger')

            this.hasNudity = true

            this.sendHeartBeat = false
            if (this.agoraCallType === 'outgoing') {
              this.leave()
            } else if (this.agoraCallType === 'incoming') {
              this.reject()
            }
          }
        })
        .catch(error => {
          console.error('[AgoraVideoCall] checkNudity error:', error?.response?.data || error)
        })
        .finally(() => {
          delete this.nudityCheckInFlight[inFlightKey]
        })
    },
    async captureNudityFrame(videoElement, includeDataUrl = false) {
      if (!videoElement || !videoElement.videoWidth || !videoElement.videoHeight) {
        return null
      }

      const { width, height } = this.getScaledFrameSize(videoElement.videoWidth, videoElement.videoHeight)
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      canvas.width = width
      canvas.height = height
      context.drawImage(videoElement, 0, 0, width, height)

      const mimeType = this.base64ImageType
      const dataUrl = includeDataUrl ? canvas.toDataURL(mimeType, this.nudityFrameQuality) : null
      const blob = await this.canvasToBlob(canvas, mimeType, this.nudityFrameQuality, dataUrl)

      return { blob, dataUrl, mimeType }
    },
    getScaledFrameSize(width, height) {
      const maxSize = this.nudityFrameMaxSize
      if (width <= maxSize && height <= maxSize) {
        return { width, height }
      }

      const ratio = Math.min(maxSize / width, maxSize / height)
      return {
        width: Math.max(1, Math.round(width * ratio)),
        height: Math.max(1, Math.round(height * ratio)),
      }
    },
    canvasToBlob(canvas, mimeType, quality, fallbackDataUrl = null) {
      return new Promise(resolve => {
        if (canvas.toBlob) {
          canvas.toBlob(blob => {
            if (blob) {
              resolve(blob)
              return
            }
            resolve(this.dataUrlToBlob(fallbackDataUrl || canvas.toDataURL(mimeType, quality), mimeType))
          }, mimeType, quality)
          return
        }
        resolve(this.dataUrlToBlob(fallbackDataUrl || canvas.toDataURL(mimeType, quality), mimeType))
      })
    },
    dataUrlToBlob(dataUrl, fallbackMimeType = 'image/png') {
      const parts = dataUrl.split(',')
      const meta = parts[0] || ''
      const base64 = parts[1] || ''
      const mimeMatch = meta.match(/data:([^;]+);base64/)
      const mimeType = mimeMatch ? mimeMatch[1] : fallbackMimeType
      const binary = atob(base64)
      const bytes = new Uint8Array(binary.length)
      for (let i = 0; i < binary.length; i += 1) {
        bytes[i] = binary.charCodeAt(i)
      }
      return new Blob([bytes], { type: mimeType })
    },
    mimeExtension(mimeType) {
      if (mimeType === 'image/jpeg') return 'jpg'
      if (mimeType === 'image/webp') return 'webp'
      return 'png'
    },
    async sendFaceDetection(callId, base64Data) {
      const image = new Image()
      image.src = base64Data

      if (image) {
        // eslint-disable-next-line no-unused-expressions
        image.onload = async () => {
          if (this.model) {
            const faces = await this.model.estimateFaces(image, { flipHorizontal: false })

            if (faces.length > 0) {
              const face = faces[0]

              // Face detection için normal veriyi gönder
              useJwt.faceDetect({
                call_id: callId,
                detect: true,
              })

              // Face zoom için face box bilgilerini güncelle
              if (face.box && face.box.width > 0 && face.box.height > 0) {
                // Local video için face box güncelle
                this.localFaceBox = this.normalizeFaceBox(face.box, image, true) // Mirror effect için

                // Auto zoom hesapla ve uygula
                if (this.autoZoom) {
                  const newZoom = this.calculateAdaptiveZoom(this.localFaceBox)
                  this.localZoomFactor = newZoom
                }

                // Local video elementine zoom uygula
                const localVideoElement = this.$refs.localePlayerContainer?.querySelector('video')
                if (localVideoElement) {
                  this.applyVideoZoom(localVideoElement, this.localFaceBox, this.localZoomFactor)
                }
              }
            } else {
              useJwt.faceDetect({
                call_id: callId,
                detect: false,
              })

              // Yüz algılanmadığında zoom'u sıfırla
              this.localFaceBox = null
              this.localZoomFactor = 1

              // Local video elementinden zoom'u kaldır
              const localVideoElement = this.$refs.localePlayerContainer?.querySelector('video')
              if (localVideoElement) {
                this.applyVideoZoom(localVideoElement, null, 1)
              }
            }
          }
        }

        image.onerror = () => {}
      }
    },
    startWatermarkAnimation() {
      this.watermarkInterval = setInterval(() => {
        const container = this.$refs.remotePlayerContainer
        if (!container) return

        // Container boyutları
        const containerWidth = container.offsetWidth
        const containerHeight = container.offsetHeight

        // Watermark elementi (geçici olarak DOM'a eklenmiş halini kontrol et)
        const watermarkEl = container.querySelector('.watermark')
        if (!watermarkEl) return

        // Watermark'ın gerçek boyutları
        const watermarkWidth = watermarkEl.offsetWidth
        const watermarkHeight = watermarkEl.offsetHeight

        // Rotasyon açısı (-15 ile 15 derece arası)
        this.watermarkRotation = Math.random() * 30 - 15

        // Rotasyon sonrası diagonal boyut hesaplama
        const radians = (this.watermarkRotation * Math.PI) / 180
        const cos = Math.abs(Math.cos(radians))
        const sin = Math.abs(Math.sin(radians))

        // Döndürülmüş elementin kaplama alanı
        const rotatedWidth = watermarkWidth * cos + watermarkHeight * sin
        const rotatedHeight = watermarkWidth * sin + watermarkHeight * cos

        // Güvenli minimum ve maksimum pozisyonlar (yüzde olarak)
        const minLeft = (rotatedWidth / 2 / containerWidth) * 100
        const maxLeft = 100 - minLeft
        const minTop = (rotatedHeight / 2 / containerHeight) * 100
        const maxTop = 100 - minTop

        // Rastgele ama güvenli pozisyon
        this.watermarkPosition.left = Math.random() * (maxLeft - minLeft) + minLeft
        this.watermarkPosition.top = Math.random() * (maxTop - minTop) + minTop
      }, 3000)
    },
    numberFormat,
    playGift(gift) {
      const fileName = gift.riv || null

      if (fileName) {
        this.riveStatus = true

        setTimeout(() => {
          this.rive1 = new Rive({
            canvas: this.$refs.canvas,
            src: `../../assets/animations/${fileName}`,
            autoplay: true,
            onStop: () => {
              this.riveStatus = false
            },
          })
        }, 11)
      }
    },
    async reject() {
      await this.cancelCall()
      if (this.callRequestInfo && this.callRequestInfo?.agoraCall?.callId) {
        await this.closeAgoraCall(this.callRequestInfo?.agoraCall?.callId, false)
      }
    },
    async sendGift(gift) {
      if (!gift) return
      if (!this.connection) return

      this.loading = true

      // Hediyeyi gönder
      const payload = {
        type: 'VIDEO_GIFT',
        content: gift.productId,
        from: this.user.id,
        to: this.agoraCallUser.id,
        giftImagePath: gift.image,
      }
      await this.connection.emit('send', payload)

      this.playGift(gift)

      this.loading = false

      this.hideGiftModal()
    },
    sendMessage() {
      console.log('sendMessage')
      // Önce gerekli kontrolleri yapın
      if (!this.chatMessage || !this.chatMessage.trim()) {
        return
      }

      if (!this.chatConnection) {
        console.error('Chat connection is not available')
        return
      }

      if (!this.socketConnected) {
        console.error('Socket is not connected')
        return
      }

      if (!this.callId || !this.callerId) {
        console.error('Call information is missing')
        return
      }

      const messageData = {
        content: this.chatMessage.trim(),
        from: this.user.id,
        from_user_name: this.user.userName,
        from_avatar_url: this.user.profile.image,
        to: this.agoraCallUser.id,
        callId: parseInt(this.callId),
        caller: this.callerId,
        timestamp: new Date().toISOString(),
      }

      try {
        this.chatConnection.emit('sendCallMsg', messageData)

        // Mesajı yerel olarak ekle (opsiyonel - backend'den gelecekse kaldırabilirsiniz)
        // this.chatMessages.push({
        //   ...payload,
        //   from_user_name: this.user.userName,
        //   from_avatar_url: this.user.profile.image,
        // })

        // Input'u temizle
        this.chatMessage = ''

        // Chat alanını en alta kaydır (mesaj sunucudan geldiğinde chatMessages izleyicisi de kaydırıyor)
        this.scrollChatToBottom()
      } catch (error) {
        console.error('Error sending message:', error)
      }
    },
    // Kullanıcı kaydırdıkça en altta mı değil mi takip et (yukarı kaydırıp okuyorsa otomatik kaydırma yapılmaz)
    onChatScroll(event) {
      const el = event && event.target
      if (!el) return
      this.chatStickToBottom = (el.scrollHeight - el.scrollTop - el.clientHeight) < 60
    },
    // Avatar vb. resimler kaydırmadan sonra yüklenip içeriği uzatırsa, kullanıcı alttaysa tekrar en alta in
    onChatContentLoad() {
      if (this.chatStickToBottom) this.scrollChatToBottom()
    },
    scrollChatToBottom() {
      // v-if ile ilk mesajda oluşan scroll alanının DOM'a gelmesini bekle
      this.$nextTick(() => {
        const scroller = this.$refs.refChatArea
        const el = scroller && scroller.$el
        if (!el) return
        el.scrollTop = el.scrollHeight
        // perfect-scrollbar çubuğunun boyutunu yeni içeriğe göre güncelle
        if (typeof scroller.update === 'function') scroller.update()
      })
    },
    showGiftModal(gift) {
      this.selectedGift = gift
      this.chooseGiftModal = false
      // this.giftModal = true

      this.sendGift(gift)
    },
    async startAgoraClient() {
      // Create an instance of the Agora Engine
      AgoraRTC.setLogLevel(3)
      await this.$store.dispatch('agora/setAgoraClient', AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' }))
      // this.agoraClient = AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' })

      this.sendHeartBeat = true

      // Karşı taraf görüşmeye katıldı
      this.agoraClient.on('user-published', async (user, mediaType) => {
        // Kullanıcının verilerini değişkene ata
        this.remoteUser = user

        // eslint-disable-next-line no-underscore-dangle
        if (user?._videoTrack?._videoHeight && user?._videoTrack?._videoWidth) {
          // eslint-disable-next-line no-underscore-dangle
          this.videoHeight = user._videoTrack._videoHeight
          // eslint-disable-next-line no-underscore-dangle
          this.videoWidth = user._videoTrack._videoWidth
        }

        // Subscribe to the remote user when the SDK triggers the "user-published" event.
        // Karşı taraf kamerayı aç/kapa yaparken abonelik yarışa girip hata verebilir; sessizce kaybolmasın,
        // yayın hâlâ sürüyorsa bir kez daha dene
        try {
          await this.agoraClient.subscribe(user, mediaType)
        } catch (error) {
          await new Promise(resolve => setTimeout(resolve, 300))
          const stillPublished = mediaType === 'video' ? user.hasVideo : user.hasAudio
          if (!stillPublished) return
          try {
            await this.agoraClient.subscribe(user, mediaType)
          } catch (retryError) {
            return
          }
        }
        this.callStatus = 'talking'

        // Subscribe and play the remote audio track.
        if (mediaType === 'audio' && user.audioTrack) {
          this.agoraChannelParameters.remoteUid = user.uid
          // Get the RemoteAudioTrack object from the AgoraRTCRemoteUser object.
          this.agoraChannelParameters.remoteAudioTrack = user.audioTrack
          // Play the remote audio track.
          this.agoraChannelParameters.remoteAudioTrack.play()

          this.remoteUserMuted = false
        }

        // Subscribe and play the remote video in the container If the remote user publishes a video track.
        if (mediaType === 'video' && user.videoTrack) {
          // Retrieve the remote video track.
          this.agoraChannelParameters.remoteVideoTrack = user.videoTrack
          // Retrieve the remote audio track.
          this.agoraChannelParameters.remoteAudioTrack = user.audioTrack
          // Save the remote user id for reuse.
          this.agoraChannelParameters.remoteUid = user.uid.toString()

          // Play the remote video track.
          this.agoraChannelParameters.remoteVideoTrack.play(this.$refs.remotePlayerContainer)
        }
      })

      // Listen for the "user-unpublished" event.
      // Hangi yayının kalktığı mediaType ile gelir; görüntü ve ses ayrı ele alınır
      // (önceden SDK'nın iç alanlarına bakılıyordu, görüntü kapanınca eski kare ekranda kalabiliyordu)
      this.agoraClient.on('user-unpublished', (user, mediaType) => {
        if (mediaType === 'video') {
          if (this.agoraChannelParameters.remoteVideoTrack) {
            this.agoraChannelParameters.remoteVideoTrack.stop()
            this.agoraChannelParameters.remoteVideoTrack = null
          }
        } else if (mediaType === 'audio') {
          this.remoteUserMuted = true
          if (this.agoraChannelParameters.remoteAudioTrack) {
            this.agoraChannelParameters.remoteAudioTrack.stop()
          }
        }
      })

      // Listen for the "user-joined" event.
      this.agoraClient.on('user-joined', async () => {
        // Backend e başladı olarak heart beat gönder
        if (this.agoraCallType === 'outgoing') {
          this.heartBeat({ callId: this.userAgoraInformation.callId, status: 1 })
        }

        this.callStatus = 'talking'

        // Heart beat durumunu değiştir
        this.heartBeatStatus = 2
        if (this.agoraCallType === 'incoming') {
          this.startSendHeartBeat(this.callRequestInfo.agoraCall.callId, 5)
        } else if (this.agoraCallType === 'outgoing') {
          this.startSendHeartBeat(this.userAgoraInformation.callId, this.userAgoraInformation.heartbeatInterval)
        }

        // Süreyi başlat
        this.startTime()
      })

      // Listen for the "user-joined" event.
      this.agoraClient.on('user-left', async () => {
        // Store'da çağrı durumunu false yap
        this.$store.dispatch('agora/setAgoraCalling', false)

        // Kullanıcı görüşmeden ayrıldı
        showNotify(this.$toast, this.$t('User has left the call'), 'info')

        if (this.agoraCallType === 'outgoing') {
          await this.closeAgoraCall(this.userAgoraInformation.callId, true, true) // TODO: daha sonra sendCompletedHeartBeat false yapılacak
        } else if (this.agoraCallType === 'incoming') {
          await this.closeAgoraCall(null, false)
        }
      })

      // Bağlantı durum değişkliğini dinle
      this.agoraClient.on('connection-state-change', async e => {
        if (e === 'CONNECTED') {
          // join() ile aynı kilitli fonksiyon: kamera/mikrofon yalnızca bir kez açılır ve yayınlanır
          try {
            await this.ensureLocalTracksPublished()
          } catch (error) {
            // localeMuted ensureLocalTracksPublished içinde ayarlanıyor
          }
        } else if (e === 'DISCONNECTED') {
          if (this.callStatus === 'talking') {
            await this.leave()
          } else if (this.callStatus === 'calling') {
            if (this.agoraCallType === 'outgoing') {
              await this.leave()
            } else if (this.agoraCallType === 'incoming') {
              await this.reject()
            }
          }
        }
      })
    },
    startCall() {
      if (this.agoraClient && this.agoraCallUser) {
        // Store'da çağrı durumunu true yap
        this.$store.dispatch('agora/setAgoraCalling', true)

        const callDetails = this.$store.getters['app/callDetails']

        this.loading = true
        useJwt.appVideoCall(this.agoraCallUser.id, callDetails)
          .then(async response => {
            if (response.data.body.callType === 'sippy') {
              showNotify(this.$toast, this.$t('Call information : agora not available, sippy is available'), 'info')
              await this.closeAgoraCall(null, false)
            } else {
              // Arayan, yanıt gelmeden aramayı kapattıysa: oluşan aramayı sunucuda iptal et ve devam etme
              // eslint-disable-next-line no-underscore-dangle
              if (this.outgoingCancelled || this._isDestroyed) {
                if (response.data.body?.callId) useJwt.appCallCancel({ callId: response.data.body.callId })
                return
              }

              this.userAgoraInformation = response.data.body

              // Kapatma butonu kamera/mikrofon açılmasını (join) beklemeden görünsün.
              // userAgoraInformation artık dolu olduğu için leave() bu noktada güvenle çalışır.
              if (this.callStatus !== 'talking') {
                this.callStatus = 'calling'
              }

              if (response.data.body?.nudityCheckInterval) {
                this.nudityCheckIntervalInSecs = response.data.body?.nudityCheckInterval
              }

              await this.$store.dispatch('agora/setAgoraOptions', {
                channel: this.userAgoraInformation.channelName,
                token: this.userAgoraInformation.token,
                uid: this.userAgoraInformation.uid,
              })
              await this.join()
              if (this.agoraCallType === 'outgoing') {
                // Heartbeat göndermeyi başlat
                // this.heartBeatStatus = 6 // TODO : kapatılacak
                // this.startSendHeartBeat(this.userAgoraInformation.callId, this.userAgoraInformation.heartbeatInterval) // TODO : kapatılacak
              }
              // Karşı taraf join sırasında bağlandıysa 'talking' durumunu geri 'calling'e çekme
              if (this.callStatus !== 'talking') {
                this.callStatus = 'calling'
              }
            }
          })
          .catch(error => {
            // Store'da çağrı durumunu false yap
            this.$store.dispatch('agora/setAgoraCalling', false)

            if (error.response?.data?.header?.error?.errorCode == '209') {
              // Kullanıcıyı market sayfasına yönlendir
              this.$router.push('/market')
            }

            this.message = this.$t('Call failed')
            throwDefaultError(this.$toast, error)

            this.closeAgoraCall(null, false)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    async startCallingTime() {
      await this.stopCallingTime()

      this.timeCallInterval = setInterval(() => {
        // eslint-disable-next-line no-plusplus
        this.timeCall++
      }, 1000)
    },
    async stopCallingTime() {
      if (this.timeCallInterval) {
        clearInterval(this.timeCallInterval)
        this.timeCallInterval = null
        this.timeCall = 0
      }
    },
    startTime() {
      this.stopCallingTime()

      // ilk seferde nudity kontrolü yap
      setTimeout(() => {
        this.scheduleNudityDetection()
      }, 1000)

      this.alreadyConnected = true

      showNotify(this.$toast, this.$t('videoCallWarningText'), 'info')
      showNotify(this.$toast, this.$t('videoCallWarningText2'), 'info')

      if (this.intervalForTime) {
        clearInterval(this.intervalForTime)
      }
      this.time = 0
      this.intervalForTime = setInterval(() => {
        // eslint-disable-next-line no-plusplus
        this.time++
        this.message = this.getDateForHuman(this.time)

        if (this.time % this.nudityCheckIntervalInSecs === 0) {
          this.scheduleNudityDetection()
        }
      }, 1000)

      // Firebase Analytics Event
      if (this.agoraCallType === 'outgoing' && window.firebaseAnalytics && this.agoraCallUser) {
        logEvent(window.firebaseAnalytics, 'web_start_call', {
          fromId: this.agoraCallUser.id,
          toId: this.agoraChannelParameters.remoteUid,
        })
      }
    },
    // Zil sesini döngüde çalar. audioUnlocked bayrağına bakmadan doğrudan dener:
    // - AbortError (play, pause ile kesildi): durum hâlâ aynıysa kısa süre sonra bir kez daha dener
    // - NotAllowedError (tarayıcı izin vermedi): "sesi aç" uyarısı görünsün diye audioUnlocked false kalır
    playRingtone(audio, status, retried = false) {
      if (!audio || this.callStatus !== status) return
      // eslint-disable-next-line no-param-reassign
      audio.loop = true
      playCallSound(audio)
        .then(() => {
          this.audioUnlocked = true
        })
        .catch(error => {
          if (error && error.name === 'AbortError' && !retried) {
            setTimeout(() => this.playRingtone(audio, status, true), 300)
          } else if (error && error.name === 'NotAllowedError') {
            this.audioUnlocked = false
            // Safari izin vermediyse zil sessizce kaybolmasın: kullanıcının ilk dokunuşunda tekrar dene
            retryOnNextInteraction(audio, () => this.callStatus === status)
          } else {
            console.warn('🔊 Zil sesi çalınamadı:', error)
          }
        })
    },
    stopAllSounds() {
      if (this.soundIncomingCall) {
        this.soundIncomingCall.pause()
        this.soundIncomingCall.currentTime = 0
      }
      if (this.soundOutgoingCall) {
        this.soundOutgoingCall.pause()
        this.soundOutgoingCall.currentTime = 0
      }
    },
    startSendHeartBeat(callId, heartbeatInterval) {
      if (this.intervalForHeartBeat) {
        clearInterval(this.intervalForHeartBeat)
        this.intervalForHeartBeat = null
      }

      // Backend heartbeat gönder
      this.intervalForHeartBeat = setInterval(() => {
        this.heartBeat({ callId, status: this.heartBeatStatus }) // status: Integer {1=started, 2=in_progress, 3=completed}
      }, heartbeatInterval * 1000)
    },
    switchCallType() {
      if (this.agoraClient && this.agoraCallUser && this.userAgoraInformation.callId) {
        this.loading = true
        useJwt.appSwitchCallType({
          callId: this.userAgoraInformation.callId,
          agoraCallType: 'audio',
        })
          .then(async response => {
            await this.handleSwitchCallType(response.data.body, 'audio')
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },

    // ---> Safari Audio Unlock Metodu <---
    async unlockSafariAudio() {
      console.log('🔊 [Safari Audio] unlockSafariAudio başlatıldı')
      console.log('🔊 [Safari Audio] Mevcut audioUnlocked durumu:', this.audioUnlocked)
      try {
        // AudioContext oluştur
        console.log('🔊 [Safari Audio] AudioContext oluşturuluyor...')
        // Safari aynı anda açık ses motoru sayısını sınırlıyor; her çağrıda yenisini açmak yerine açık olanı kullan
        if (!this.audioContext || this.audioContext.state === 'closed') {
          this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
        }
        console.log('🔊 [Safari Audio] AudioContext oluşturuldu:', this.audioContext)
        console.log('🔊 [Safari Audio] AudioContext state:', this.audioContext.state)
        if (this.audioContext.state === 'suspended') {
          console.log('🔊 [Safari Audio] AudioContext suspended, resume ediliyor...')
          await this.audioContext.resume()
          console.log('🔊 [Safari Audio] AudioContext resumed, yeni state:', this.audioContext.state)
        }

        // iOS/Safari için "unlock" hilesi: çok kısa ve sessiz bir ses üret
        console.log('🔊 [Safari Audio] iOS/Safari unlock hilesi başlatılıyor...')
        const oscillator = this.audioContext.createOscillator()
        const gainNode = this.audioContext.createGain()
        gainNode.gain.value = 0.0001 // Neredeyse sessiz
        oscillator.connect(gainNode).connect(this.audioContext.destination)
        oscillator.start()
        oscillator.stop(this.audioContext.currentTime + 0.05)
        console.log('🔊 [Safari Audio] iOS/Safari unlock hilesi tamamlandı')

        // Ses dosyalarını yeniden yükle (çalmakta olanı load() ile kesme)
        console.log('🔊 [Safari Audio] Ses dosyaları yeniden yükleniyor...')
        console.log('🔊 [Safari Audio] soundEndCall:', this.soundEndCall)
        console.log('🔊 [Safari Audio] soundIncomingCall:', this.soundIncomingCall)
        console.log('🔊 [Safari Audio] soundOutgoingCall:', this.soundOutgoingCall)
        if (this.soundEndCall && this.soundEndCall.paused) {
          this.soundEndCall.load()
          console.log('🔊 [Safari Audio] soundEndCall.load() çağrıldı')
        }
        if (this.soundIncomingCall && this.soundIncomingCall.paused) {
          this.soundIncomingCall.load()
          console.log('🔊 [Safari Audio] soundIncomingCall.load() çağrıldı')
        }
        if (this.soundOutgoingCall && this.soundOutgoingCall.paused) {
          this.soundOutgoingCall.load()
          console.log('🔊 [Safari Audio] soundOutgoingCall.load() çağrıldı')
        }

        this.audioUnlocked = true
        localStorage.setItem('audioUnlocked', '1')
        console.log('🔊 [Safari Audio] Audio unlock başarılı! audioUnlocked:', this.audioUnlocked)
        // ---> Test ses çalma - kullanıcı etkileşimi sonrası <---
        try {
          console.log('🔊 [Safari Audio] Test ses çalınıyor...')
          // Çok kısa bir test sesi çal
          const testAudio = new Audio()
          testAudio.src = this.soundEndCall.src
          testAudio.volume = 0.1
          await testAudio.play()
          console.log('🔊 [Safari Audio] Test ses başarıyla çalındı!')
          // Test sesini hemen durdur
          testAudio.pause()
          testAudio.currentTime = 0
        } catch (testError) {
          console.error('🔊 [Safari Audio] Test ses çalınamadı:', testError)
        }
        // ---> End test ses çalma <---
        return true
      } catch (error) {
        console.error('🔊 [Safari Audio] Audio unlock başarısız:', error)
        console.error('🔊 [Safari Audio] Error details:', {
          name: error.name,
          message: error.message,
          stack: error.stack,
        })
        return false
      }
    },
    // ---> End Safari Audio Unlock <---
    // ---> Visibility Change Handler <---
    async handleVisibilityChange() {
      console.log('🔊 [Visibility] Sayfa görünürlük değişti, hidden:', document.hidden)
      console.log('🔊 [Visibility] AudioContext mevcut mu:', !!this.audioContext)
      if (!document.hidden && this.audioContext && this.audioContext.state === 'suspended') {
        console.log('🔊 [Visibility] AudioContext suspended, resume ediliyor...')
        try {
          await this.audioContext.resume()
          console.log('🔊 [Visibility] AudioContext resumed, yeni state:', this.audioContext.state)
        } catch (error) {
          console.error('🔊 [Visibility] AudioContext resume başarısız:', error)
        }
      } else {
        console.log('🔊 [Visibility] AudioContext resume gerekli değil veya mevcut değil')
      }
    },
    // ---> End Visibility Change Handler <---

    onCallViewportChange() {
      const vv = window.visualViewport
      if (!vv) return
      const open = this.expanded && !this.isHidden && window.innerWidth <= 991
        && window.innerHeight - vv.height > 150
      const rootStyle = document.documentElement.style
      if (open) {
        rootStyle.setProperty('--vc-h', `${Math.round(vv.height)}px`)
        rootStyle.setProperty('--vc-top', `${Math.round(vv.offsetTop)}px`)
        document.body.classList.add('vc-kb-open')
      } else {
        rootStyle.removeProperty('--vc-h')
        rootStyle.removeProperty('--vc-top')
        document.body.classList.remove('vc-kb-open')
      }
    },
    // ---> Face Zoom Methods <---
    // Yüz kutusu, yüzün algılandığı karenin boyutuna göre 0-1 aralığına çevrilir.
    // Önceden kutu 480px'e küçültülmüş karede ölçülüp videonun gerçek boyutuyla (720x1280 ya da karşı
    // tarafın boyutu) kıyaslanıyordu; yüz olduğundan çok küçük sanılıyor, zoom hep 2x'e ve kenara
    // kayıyordu (mobilde görüntünün aniden "kocaman" olması).
    normalizeFaceBox(box, image, mirror) {
      const width = image.naturalWidth || image.width
      const height = image.naturalHeight || image.height
      if (!width || !height) return null
      const xMin = (mirror ? width - box.xMax : box.xMin) / width
      return {
        xMin,
        xMax: xMin + box.width / width,
        yMin: box.yMin / height,
        yMax: box.yMax / height,
        width: box.width / width,
        height: box.height / height,
      }
    },
    calculateAdaptiveZoom(faceBox) {
      if (!faceBox || !this.autoZoom) {
        return 1
      }

      // faceBox 0-1 aralığında (bkz. normalizeFaceBox): alanı doğrudan videodaki oranıdır
      const faceRatio = faceBox.width * faceBox.height

      const idealFaceRatio = 0.175 // %17.5
      let adaptiveZoom = Math.sqrt(idealFaceRatio / faceRatio)

      adaptiveZoom = Math.max(1, Math.min(2, adaptiveZoom))

      return Math.round(adaptiveZoom * 10) / 10
    },
    applyVideoZoom(videoElement, faceBox, zoomFactor) {
      if (!videoElement) {
        return
      }

      if (!faceBox || zoomFactor === 1) {
        videoElement.style.transform = 'scale(1) translate(0, 0)'
        videoElement.style.transformOrigin = 'center center'
        videoElement.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
        return
      }

      // Yüzün merkez noktasını hesapla
      const faceCenterX = faceBox.xMin + faceBox.width / 2
      const faceCenterY = faceBox.yMin + faceBox.height / 2

      // faceBox zaten 0-1 aralığında (bkz. normalizeFaceBox)
      const normalizedX = faceCenterX
      const normalizedY = faceCenterY

      // Merkezi hedefleyerek translate değerlerini hesapla
      // 0.5 video merkezini temsil eder
      const translateX = (0.5 - normalizedX) * 100
      const translateY = (0.5 - normalizedY) * 100

      // Zoom faktörüne göre translate değerlerini ayarla
      const adjustedTranslateX = translateX / zoomFactor
      const adjustedTranslateY = translateY / zoomFactor

      // Transform'u uygula - önce translate, sonra scale
      videoElement.style.transform = `translate(${adjustedTranslateX}%, ${adjustedTranslateY}%) scale(${zoomFactor})`
      videoElement.style.transformOrigin = 'center center'
      videoElement.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
    },
    async sendRemoteFaceDetection(base64Data) {
      const image = new Image()
      image.src = base64Data

      if (image) {
        // eslint-disable-next-line no-unused-expressions
        image.onload = async () => {
          if (this.model) {
            const faces = await this.model.estimateFaces(image, { flipHorizontal: false })

            if (faces.length > 0) {
              const face = faces[0]

              // Remote video için face box güncelle
              if (face.box && face.box.width > 0 && face.box.height > 0) {
                this.remoteFaceBox = this.normalizeFaceBox(face.box, image, false)

                // Auto zoom hesapla ve uygula
                if (this.autoZoom) {
                  const newZoom = this.calculateAdaptiveZoom(this.remoteFaceBox)
                  this.remoteZoomFactor = newZoom
                }

                // Remote video elementine zoom uygula
                const remoteVideoElement = this.$refs.remotePlayerContainer?.querySelector('video')
                if (remoteVideoElement) {
                  this.applyVideoZoom(remoteVideoElement, this.remoteFaceBox, this.remoteZoomFactor)
                }
              }
            } else {
              // Yüz algılanmadığında zoom'u sıfırla
              this.remoteFaceBox = null
              this.remoteZoomFactor = 1

              // Remote video elementinden zoom'u kaldır
              const remoteVideoElement = this.$refs.remotePlayerContainer?.querySelector('video')
              if (remoteVideoElement) {
                this.applyVideoZoom(remoteVideoElement, null, 1)
              }
            }
          }
        }

        image.onerror = () => {}
      }
    },
    // ---> End Face Zoom Methods <---
  },
}
</script>

<style lang="scss" scoped>
#agora-video-call {
  position: fixed;
  left: 24px;
  bottom: 24px;
  max-height: 90%;
  z-index: 9999999999 !important;

  // Mobilde küçültülmüş arama balonu alt menünün ve kampanya şeridinin üstünde dursun
  @media (max-width: 768px) {
    left: 16px;
    bottom: calc(146px + env(safe-area-inset-bottom, 0px));
  }

  .expanded {
    padding: 16px;
    border-radius: 16px;
    width: 280px;
    position: relative;

    .call-information {
      .user-information {
        display: flex;
        font-size: 18px;
        font-weight: 500;
        color: #2C3333;
        gap: 6px;

        div:first-of-type {
          display: flex;
          flex-direction: column;
          justify-content: center;
          color: #322E42 !important;
          font-family: 'Inter', sans-serif !important;

          span.username {
            font-size: 15px !important;
            font-weight: 600;
            width: 100px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          span.status {
            font-size: 11px !important;
            font-weight: 400;
          }
        }
      }
    }

    .agora-call-buttons {
      display: flex;
      flex-direction: column !important;
      justify-content: end;
      gap: 8px;

      * {
        cursor: pointer;
      }
    }

    .window-actions {
      display: flex;
      align-items: start;
      position: absolute;
      right: 16px;
      top: 20px;

      .minus {
        font-size: 20px;
        line-height: 4px;
        cursor: pointer;
        -webkit-transform: scale(2.0, 1.4);
        -moz-transform: scale(2.0, 1.4);
        -ms-transform: scale(2.0, 1.4);
        -o-transform: scale(2.0, 1.4);
        transform: scale(2.0,1.4);
      }
    }
  }

  .not-expanded {
    position: relative;
    width: 84px;
    height: 84px;
    border-radius: 50%;
    overflow: clip;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .static-blink {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      position: absolute;
      left: 2px;
      top: 2px;
      outline: 2px solid #a9ead9;
    }

    .blink {
      width: 84px;
      height: 84px;
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: 0;
      outline: 2px solid #a9ead9;
      animation: blink-animation 1s steps(20, start) infinite;
      -webkit-animation: blink-animation 1s steps(20, start) infinite;
    }
    @keyframes blink-animation {
      to {
        width: 64px;
        height: 64px;
        left: 10px;
        top: 10px;
      }
    }
    @-webkit-keyframes blink-animation {
      to {
        width: 84px;
        height: 84px;
        left: 0;
        top: 0;
      }
    }
  }
}

.safari-audio-unlock-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999998;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding: 20px;

  .safari-audio-unlock-content {
    background-color: rgba(0, 0, 0, 0.7);
    padding: 30px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .safari-audio-unlock-icon {
    font-size: 60px;
  }

  .safari-audio-unlock-text {
    font-size: 18px;
    color: #fff;
    margin-bottom: 20px;
  }

  .safari-audio-unlock-button {
    background-color: #007bff;
    color: #fff;
    padding: 10px 20px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #0056b3;
    }
  }
}

.video-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.watermark {
  position: absolute !important;
  font-size: 18px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.8);
  pointer-events: none;
  user-select: none;
  z-index: 999999 !important;
  transition: all 2s ease-in-out;
  text-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);
  font-family: Arial, sans-serif;
  white-space: nowrap;
  opacity: 0.35;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
}
</style>

<style lang="scss">
#video-container {
  position: relative;

  image {
    width: 100%;
    object-fit: contain !important;
  }

  .rive-container {
    position: absolute;
    width: calc(100%);
    height: calc(100% - 170px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    // Hediye animasyonu butonlara gelen tıklamaları engellemesin
    pointer-events: none;

    // Sabit 360x460 tuval kısa ekranlarda kesiliyordu; oranı koruyarak alana sığdır
    .rive {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    }
  }

  // Sohbet artık video alanının (.remote-wrap) içinde: alt panele göre tahmini 196px yerine
  // videonun altına göre konumlanır ve kendi önizlemenin üstüne çıkmaz
  #chat-area {
    position: absolute;
    bottom: 16px;
    right: 16px;
    max-height: min(320px, calc(100% - 156px));
    width: 320px;
    z-index: 99;
    font-size: 12px;

    // Overlay arka plan
    background: rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 12px;
    padding: 12px;

    // Gölge efekti
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);

    // Scrollbar stilleri
    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.1);
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.3);
      border-radius: 3px;

      &:hover {
        background: rgba(255, 255, 255, 0.4);
      }
    }

    .chat-messages-container {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .chat-message-item {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      padding: 8px;
      border-radius: 8px;
      background: rgba(223, 74, 246, 0.1);
      backdrop-filter: blur(5px);
      transition: all 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.15);
      }

      // Kendi mesajları sağa yasla
      &.own-message {
        flex-direction: row-reverse;
        background: rgba(255, 255, 255, 0.1);

        .message-content {
          align-items: flex-end;
          text-align: right;
        }
      }

      .message-avatar {
        flex-shrink: 0;
      }

      .message-content {
        display: flex;
        flex-direction: column;
        gap: 2px;
        flex: 1;
        min-width: 0; // Uzun metinlerin taşmasını önle

        .message-sender {
          font-weight: 600;
          color: #fff;
          font-size: 13px;
          opacity: 0.9;
        }

        .message-text {
          color: #fff;
          font-size: 12px;
          line-height: 1.4;
          word-wrap: break-word;
          overflow-wrap: anywhere; // boşluksuz uzun metin/link kutudan taşmasın
          opacity: 0.95;
        }
      }
    }
  }

  // Mobil için responsive ayarlar
  @media (max-width: 768px) {
    #chat-area {
      width: calc(100% - 100px);
      right: 10px;
      bottom: 12px;
      max-height: min(250px, calc(100% - 150px));
    }
  }

  .agora-call-buttons {
    display: flex;
    flex-direction: column;
    justify-content: end;
    gap: 8px;

    .incoming-buttons {
      display: flex;
      width: 100%;
      justify-content: center !important;
      gap: 16px;
    }

    * {
      cursor: pointer;
    }
  }

  #remotePlayerContainer {
    width: 100%;
    // Kısa laptop ekranlarında video + alt panel pencereye sığsın, kapat butonu ekranın altında kalmasın
    height: 420px;
    height: min(420px, calc(100vh - 260px));
    height: min(420px, calc(100dvh - 260px));
    min-height: 240px;
    position: relative;
    overflow: hidden;
    background-color: #1e1e1e;
    border-top-left-radius: 16px !important;
    border-top-right-radius: 16px !important;

    &.blur {
      overflow: hidden;
      -webkit-filter: blur(30px);
      -moz-filter: blur(30px);
      -o-filter: blur(30px);
      -ms-filter: blur(30px);
      filter: blur(30px);
    }

    div {
      z-index: 2;
    }

    video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: contain !important;
      z-index: 2;
    }

    img {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }

    .video-actions {
      position: absolute;
      left: 10px;
      bottom: 16px;
      z-index: 9999999999999999 !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      padding: 8px !important;
      flex-direction: column;
      gap: 8px;

      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        cursor: pointer;
        border-radius: 50%;
        background-color: #fff;
      }

      img {
        width: 24px !important;
        height: 24px !important;
        cursor: pointer;
        position: relative;
      }
    }
  }

  @media (max-width: 768px) {
    .agora-call-buttons {
      justify-content: start !important;
    }
  }

  // Kamera görüntüsü yatay (4:3) olduğu için kare kartta siyah bant kalıyordu
  #localePlayerContainer {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 144px;
    height: 108px;
    border-radius: 12px;
    background: #000;
    z-index: 10;

    &.blur {
      overflow: hidden;
      -webkit-filter: blur(30px);
      -moz-filter: blur(30px);
      -o-filter: blur(30px);
      -ms-filter: blur(30px);
      filter: blur(30px);
    }

    div {
      z-index: 5;
    }

    video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: contain !important;
      z-index: 6;
    }

    img {
      position: absolute;
      z-index: 4;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }
  }

  .call-information {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .user-information {
      display: flex;
      font-size: 18px;
      font-weight: 500;
      color: #2C3333;
      gap: 6px;

      div:first-of-type {
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: #322E42 !important;
        font-family: 'Inter', sans-serif !important;

        span.username {
          font-size: 15px !important;
          font-weight: 600;
          width: 100px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        span.status {
          font-size: 11px !important;
          font-weight: 400;
        }
      }
    }
  }

  .call-bottom {
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    background-color: rgba(255, 255, 255, 0.6);
    padding: 16px 8px !important;
    border-bottom-left-radius: 16px !important;
    border-bottom-right-radius: 16px !important;
  }
}

.call-content, .call-body, #video-container, .user-information {
  background: none !important;
}

.minimize-icon {
  position: absolute;
  left: 48%;
  top: 20px;
  cursor: pointer;
  z-index: 999;
  background-color: #1e1e1e;
  border-radius: 50%;
  padding: 4px;
}

.hidden-modal {
  display: block !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;

  & ~ .modal-backdrop {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }
}

/* =========================================================
   Görüntülü arama — yeni koyu UI (video alanlarına dokunulmadı)
   ========================================================= */
// Dış kap şeffaf ve içinde boşluk olduğu için kenarlığı/parlaması görünen kartın ~18px dışında
// ikinci bir çerçeve gibi duruyordu; görünen kart (video + alt panel) kendi köşeleriyle kalır
.call-content {
  border-radius: 22px !important;
  overflow: hidden;
  border: 0 !important;
  box-shadow: none !important;
}

#agora-video-call,
.call-body {
  .minimize-icon,
  & .minimize-icon {
    left: 50%;
    transform: translateX(-50%);
    top: 14px;
    width: 40px;
    height: 40px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(14, 10, 40, 0.7);
    border: 1px solid rgba(170, 140, 255, 0.4);
    backdrop-filter: blur(6px);

    svg { width: 18px; height: 10px; }
  }
}

.call-body {
  .call-bottom {
    background: linear-gradient(160deg, #2b1a63 0%, #1d1247 55%, #3a1356 100%) !important;
    backdrop-filter: none;
    padding: 14px 16px 16px !important;
    border-top: 1px solid rgba(234, 3, 178, 0.3);

    .form-send-message {
      .form-control {
        background: rgba(14, 10, 40, 0.6) !important;
        border: 1px solid rgba(170, 140, 255, 0.3) !important;
        border-right: 0 !important;
        color: #fff !important;
        border-radius: 9999px 0 0 9999px !important;

        &::placeholder { color: rgba(226, 220, 255, 0.5); }
      }

      .input-group-text {
        background: rgba(14, 10, 40, 0.6) !important;
        border: 1px solid rgba(170, 140, 255, 0.3) !important;
        border-left: 0 !important;
        border-radius: 0 9999px 9999px 0 !important;

        > div {
          background: linear-gradient(135deg, #ff1f8f, #7c3aed) !important;
          display: flex;
          align-items: center;
          justify-content: center;

          img { filter: brightness(0) invert(1); }
        }
      }
    }
  }

  .vc-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    flex-wrap: wrap;
  }

  .vc-user {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;

    .vc-avatar {
      flex-shrink: 0;
      box-shadow: 0 0 0 2px #ea03b2, 0 0 16px rgba(234, 3, 178, 0.45);
    }

    .vc-user-text {
      display: flex;
      flex-direction: column;
      min-width: 0;
      color: #fff !important;

      span.username {
        color: #fff !important;
        font-family: inherit !important;
        font-size: 17px !important;
        font-weight: 800;
        width: auto !important;
        max-width: 180px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      span.status {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        color: rgba(236, 232, 255, 0.8) !important;
        font-size: 13px !important;
      }
    }
  }

  .vc-status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #f59e0b;
    box-shadow: 0 0 8px #f59e0b;

    &.talking { background: #22c55e; box-shadow: 0 0 8px #22c55e; }
    &.ended { background: #ef4444; box-shadow: 0 0 8px #ef4444; }
  }

  .vc-buttons {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    justify-content: flex-end;
    gap: 12px !important;
    margin-left: auto;

    @media (max-width: 639px), (max-height: 500px) and (orientation: landscape) {
      width: 100%;
      justify-content: center;
    }
  }

  .vc-btn {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    border: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
    transition: transform .15s ease, filter .15s ease;

    &:hover { transform: scale(1.08); filter: brightness(1.1); }

    &.accept {
      background: linear-gradient(135deg, #10b981, #22c55e);
      box-shadow: 0 8px 20px rgba(16, 185, 129, 0.5);
    }

    &.reject {
      background: linear-gradient(135deg, #ef4444, #e11d48);
      box-shadow: 0 8px 20px rgba(239, 68, 68, 0.5);
    }

    &.neutral {
      background: rgba(255, 255, 255, 0.12);
      border: 1px solid rgba(255, 255, 255, 0.22);

      &.off {
        background: rgba(239, 68, 68, 0.22);
        border-color: rgba(239, 68, 68, 0.55);
        color: #fca5a5;
      }
    }
  }
}

/* =========================================================
   Görüntülü arama — MOBİL (575px altı): tam ekran düzen.
   Karşı tarafın görüntüsü ekranı doldurur, kendi önizlemen sağ üstte küçük kart,
   sohbet görüntünün üstünde altta, kontroller en altta. Masaüstü düzeni değişmez.
   ========================================================= */
// Yatay tutulan telefon da (genişlik 575px'i geçse bile kısa ekran) mobil düzeni kullanır;
// önceden masaüstü düzeni (420px video + alt panel) açılıyor, ekran taşıyor ve butonlar kayboluyordu.
@media (max-width: 639px), (max-height: 500px) and (orientation: landscape) {
  // Şablonun genel CSS'i dar ekranlarda tüm modal'lara 1rem kenar boşluğu veriyor; arama ekranı
  // bu yüzden tam ekran yerine kenarları boşluklu bir kart gibi görünüyordu
  [dir] .modal.call-modal {
    padding: 0 !important;
  }

  .call-dialog {
    margin: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
    height: 100vh;
    height: 100dvh;
    min-height: 0 !important;
    align-items: stretch !important;
  }

  .call-dialog .modal-content.call-content {
    height: 100vh;
    height: 100dvh;
    border: 0 !important;
    border-radius: 0 !important;
  }

  .call-body {
    padding: 0 !important;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    // Video alanı kalan tüm yüksekliği alır
    #video-container {
      flex: 1 1 auto;
      min-height: 0;
      display: flex;
      flex-direction: column;

      // :has() yerine sınıf: eski iOS/Samsung tarayıcılarında :has() desteklenmiyor, video alanı çöküyordu
      > .remote-wrap {
        flex: 1 1 auto;
        min-height: 0;
      }

      #remotePlayerContainer {
        height: 100% !important;
        border-radius: 0 !important;
      }

      // Kendi görüntün: sağ üstte dikey küçük kart (küçültme butonunun altında)
      #localePlayerContainer {
        top: 64px;
        right: 12px;
        width: 92px;
        height: 124px;
        border-radius: 14px;
        overflow: hidden;
        border: 2px solid rgba(255, 255, 255, 0.35);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.45);
        z-index: 10;
      }

      // Sohbet: görüntünün üstünde, en altta tam genişlik
      #chat-area {
        left: 12px;
        right: 12px;
        bottom: 12px;
        width: auto;
        // Artık yalnızca video alanının yüzdesi (önceden tüm ekranın), yüzü kapatmadan biraz daha fazla mesaj
        max-height: 40%;
        padding: 8px;
      }

      .rive-container {
        height: 100%;
      }
    }

    // Alt panel: kontroller + mesaj kutusu, iPhone alt boşluğu dahil
    .call-bottom {
      flex: 0 0 auto;
      border-radius: 0 !important;
      padding: 10px 12px calc(12px + env(safe-area-inset-bottom, 0px)) !important;
    }

    .vc-info {
      gap: 10px;
    }

    .vc-user {
      .vc-avatar {
        width: 40px !important;
        height: 40px !important;
      }

      .vc-user-text span.username {
        font-size: 15px !important;
        max-width: 160px;
      }
    }

    .vc-buttons {
      gap: 14px !important;
    }

    .vc-btn {
      width: 52px;
      height: 52px;
    }
  }
}

// Yatay telefonda kendi önizlemen yatay ve üstte, yükseklik kısıtlı olduğu için daha kompakt
@media (max-height: 500px) and (orientation: landscape) {
  .call-body #video-container #localePlayerContainer {
    top: 12px;
    width: 124px;
    height: 92px;
  }
}

// Dokunmatik: butonlara hızlı iki dokunuşta sayfa yakınlaşmasın, hover büyümesi takılı kalmasın
.call-body {
  touch-action: manipulation;
}

@media (hover: none) {
  .call-body .vc-btn:hover {
    transform: none !important;
  }
}

// Otomatik yakınlaştırılan kendi görüntün kartın dışına taşmasın
#localePlayerContainer {
  overflow: hidden;
}

// Mobil dikey
@media (max-width: 639px) {
  // Küçültme butonu en az 44px dokunma alanı
  .call-body .minimize-icon {
    width: 44px !important;
    height: 44px !important;
  }

  // Aranırken/çalarken karşı tarafın fotoğrafı tam ekranı doldursun (küçük, siyah bantlı kalıyordu)
  .call-body #video-container #remotePlayerContainer img {
    object-fit: cover !important;
  }
}

// Mobilde arama içi sohbete yazarken klavye açık (bkz. onCallViewportChange): düzen görünen alana sığar,
// video ve butonlar ekranın dışına itilmez. Klavye kapanınca normal düzene döner.
body.vc-kb-open {
  .call-dialog,
  .call-dialog .modal-content.call-content {
    height: var(--vc-h) !important;
  }

  .call-dialog {
    transform: translateY(var(--vc-top, 0px)) !important;
  }

  // Yazarken: kişi bilgisi ve butonlar gizlenir, yazma kutusu klavyenin hemen üstünde kalır,
  // video kalan alanı doldurur. Klavye kapanınca normal düzene döner.
  .call-body .call-bottom {
    padding-top: 8px !important;
    padding-bottom: 8px !important;

    .vc-info { display: none !important; }

    .vc-chat-input {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
  }

  // Kısalan videoda kendi görüntün küçülür ve mesajlar onun üstüne binmez
  .call-body #video-container #localePlayerContainer {
    top: 12px;
    width: 72px;
    height: 96px;
  }

  .call-body #video-container #chat-area {
    max-height: calc(100% - 120px);
  }

  .call-body .minimize-icon {
    display: none !important;
  }
}

// Nirva düzeni (renkler Boho'nun):
// - 640px ve üstü: ortalanmış kart, en fazla 800px genişlik, yükseklik min(88dvh, 720px);
//   video sabit 420px yerine kalan alanı doldurur
// - 640px altı: tam ekran (yukarıdaki mobil blok)
@media (min-width: 640px) and (min-height: 501px) {
  .call-dialog {
    max-width: 800px !important;
    width: calc(100% - 32px) !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .call-dialog .modal-content.call-content {
    height: min(88vh, 720px);
    height: min(88dvh, 720px);
  }

  .call-body {
    display: flex;
    flex-direction: column;
    height: 100%;

    #video-container {
      flex: 1 1 auto;
      min-height: 0;
      display: flex;
      flex-direction: column;

      > .remote-wrap {
        flex: 1 1 auto;
        min-height: 0;
      }

      #remotePlayerContainer {
        height: 100% !important;
        min-height: 0;
      }
    }
  }
}

// Karşı tarafın görüntüsü ve kendi önizlemen her ekranda kırpılarak doldurulur (siyah bant yok)
.call-body #video-container #remotePlayerContainer video,
.call-body #video-container #localePlayerContainer video,
.call-body #video-container #localePlayerContainer img {
  object-fit: cover !important;
}

// Kendi önizlemen: sağ üstte dikey kart — 768px altında 96x144, üstünde 144x208
.call-body #video-container #localePlayerContainer {
  top: 64px;
  right: 16px;
  width: 96px;
  height: 144px;
  border-radius: 16px;
}

@media (min-width: 768px) {
  .call-body #video-container #localePlayerContainer {
    width: 144px;
    height: 208px;
  }
}

// Görüşme içi sohbet: her ekranda videonun sağ altında, en fazla 320px genişlik
.call-body #video-container #chat-area {
  left: auto;
  right: 12px;
  bottom: 12px;
  width: min(320px, calc(100% - 24px));
  max-height: min(320px, 45vh);
}

// 640px altı: kişi bilgisi ve butonlar ortada
@media (max-width: 639px) {
  .call-body #video-container .vc-info {
    justify-content: center;
  }

  .call-body #video-container .vc-buttons {
    width: 100%;
    justify-content: center !important;
    margin-left: 0;
  }
}

// Yatay telefonda (kısa ekran) önizleme yatay ve kompakt kalır
@media (max-height: 500px) and (orientation: landscape) {
  .call-body #video-container #localePlayerContainer {
    top: 12px;
    width: 124px;
    height: 92px;
  }
}

// Gelen görüntülü aramada her ekranda: Kabul et en solda, Reddet en sağda (arada mikrofon/kamera)
.call-body .vc-btn.incoming-accept { order: -1; }
.call-body .vc-btn.incoming-reject { order: 99; }
</style>
